var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _polygon, _path56, _circle, _path57, _path58, _path59, _path60, _path61;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.1,
    y: 252.1,
    width: 114.18,
    height: 211.2,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.19,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(912.05 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.01,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(891.69 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.83,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(871.33 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.65,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(850.97 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.97,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(831.61 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(811.67 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.82,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(791.31 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(769.68 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.82,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(749.32 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 336.39,
    width: 5.67,
    height: 119.9,
    transform: "translate(729.5 792.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.83,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(911.34 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.65,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(890.98 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.47,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(870.62 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.29,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(850.25 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.61,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(830.89 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.64,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(810.96 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.46,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(790.59 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.06,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(767.8 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.88,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(747.44 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.22,
    y: 265.97,
    width: 5.67,
    height: 63.21,
    transform: "translate(728.12 595.15) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.31,464.3c-.13,0-.23-47.4-.23-105.87s.1-105.89.23-105.89.22,47.4.22,105.89S352.43,464.3,352.31,464.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.25,
    y: 285.28,
    width: 93.47,
    height: 177.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.56,
    y: 315.47,
    width: 6.57,
    height: 138.85,
    transform: "translate(507.7 769.79) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.77,
    y: 315.47,
    width: 6.57,
    height: 138.85,
    transform: "translate(484.12 769.79) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.99,
    y: 315.47,
    width: 6.57,
    height: 138.85,
    transform: "translate(460.54 769.79) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 315.47,
    width: 6.57,
    height: 138.85,
    transform: "translate(436.96 769.79) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.99,
    y: 315.47,
    width: 6.57,
    height: 138.85,
    transform: "translate(414.55 769.79) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.44,
    y: 315.47,
    width: 6.57,
    height: 138.85,
    transform: "translate(391.46 769.79) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.65,
    y: 315.47,
    width: 6.57,
    height: 138.85,
    transform: "translate(367.88 769.79) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.15,
    y: 293.99,
    width: 6.57,
    height: 13.13,
    transform: "translate(506.87 601.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.36,
    y: 293.99,
    width: 6.57,
    height: 13.13,
    transform: "translate(483.3 601.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.57,
    y: 293.99,
    width: 6.57,
    height: 13.13,
    transform: "translate(459.72 601.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.79,
    y: 293.99,
    width: 6.57,
    height: 13.13,
    transform: "translate(436.14 601.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.58,
    y: 293.99,
    width: 6.57,
    height: 13.13,
    transform: "translate(413.72 601.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.03,
    y: 293.99,
    width: 6.57,
    height: 13.13,
    transform: "translate(390.63 601.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.24,
    y: 293.99,
    width: 6.57,
    height: 13.13,
    transform: "translate(367.06 601.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.68,
    y: 313.42,
    width: 87.98,
    height: 150.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.76,
    y: 353.97,
    width: 6.19,
    height: 103.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.85,
    y: 353.97,
    width: 6.18,
    height: 103.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.95,
    y: 353.97,
    width: 6.19,
    height: 103.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.05,
    y: 353.97,
    width: 6.18,
    height: 103.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.6,
    y: 353.97,
    width: 6.18,
    height: 103.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.46,
    y: 353.97,
    width: 6.19,
    height: 103.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.56,
    y: 353.97,
    width: 6.18,
    height: 103.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.14,
    y: 322.78,
    width: 6.19,
    height: 24.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.24,
    y: 322.78,
    width: 6.19,
    height: 24.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.34,
    y: 322.78,
    width: 6.19,
    height: 24.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.43,
    y: 322.78,
    width: 6.18,
    height: 24.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.98,
    y: 322.78,
    width: 6.18,
    height: 24.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.85,
    y: 322.78,
    width: 6.19,
    height: 24.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.95,
    y: 322.78,
    width: 6.19,
    height: 24.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.11,
    y: 177.51,
    width: 93.84,
    height: 286.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.76,
    y: 92.28,
    width: 23.05,
    height: 4.31,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.32,
    y: 58.13,
    width: 3.67,
    height: 35.41,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.73,
    y: 96.59,
    width: 65.12,
    height: 82.31,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.84,
    y: 106.74,
    width: 6.47,
    height: 66.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.44,
    y: 106.74,
    width: 6.47,
    height: 66.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.04,
    y: 106.74,
    width: 6.47,
    height: 66.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.64,
    y: 106.74,
    width: 6.47,
    height: 66.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.67,
    y: 106.74,
    width: 6.47,
    height: 66.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.73,
    y: 189.26,
    width: 6.6,
    height: 263.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.56,
    y: 189.26,
    width: 6.6,
    height: 263.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.4,
    y: 189.26,
    width: 6.6,
    height: 263.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.23,
    y: 189.26,
    width: 6.6,
    height: 263.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.49,
    y: 189.26,
    width: 6.6,
    height: 263.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.08,
    y: 189.26,
    width: 6.6,
    height: 263.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.91,
    y: 189.26,
    width: 6.6,
    height: 263.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.79,402a25.08,25.08,0,0,1,6.16-2.68l1.27-6.1,10.31-.18L133,399a25.16,25.16,0,0,1,6.26,2.46l5.21-3.42,7.41,7.17-3.23,5.32a25.31,25.31,0,0,1,2.68,6.17l6.1,1.27.18,10.3-6.05,1.49a25.09,25.09,0,0,1-2.46,6.25l3.42,5.21-7.16,7.42L140,445.45a25.31,25.31,0,0,1-6.17,2.68l-1.27,6.1-10.3.18-1.49-6.05a25.09,25.09,0,0,1-6.25-2.46l-5.21,3.41-7.42-7.16,3.23-5.32a25.31,25.31,0,0,1-2.68-6.17l-6.1-1.27-.18-10.31,6-1.48a25.16,25.16,0,0,1,2.46-6.26l-3.41-5.21,7.16-7.41,5.33,3.23Zm5.49,13.73a11.06,11.06,0,1,0,15.64-.28A11.06,11.06,0,0,0,119.28,415.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.49,227.85a31.91,31.91,0,1,1-34.43-29.09A31.88,31.88,0,0,1,574.49,227.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.93,228.48a24.32,24.32,0,1,1-26.24-22.17A24.3,24.3,0,0,1,566.93,228.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.86,227.72c-.15,0-.34-1-.88-2.86a26,26,0,0,0-3.42-7.2,24.66,24.66,0,0,0-3.57-4.13,24.1,24.1,0,0,0-5.1-3.61,22.73,22.73,0,0,0-3.09-1.36,23.55,23.55,0,0,0-3.39-.95,23.87,23.87,0,0,0-3.62-.43,24.89,24.89,0,0,0-3.75.13,26,26,0,0,0-3.68.72,23.64,23.64,0,0,0-3.43,1.24,22.36,22.36,0,0,0-3.09,1.69,21.16,21.16,0,0,0-2.7,2,23.92,23.92,0,0,0-4.15,4.66,24.38,24.38,0,0,0-2.55,4.84,26.08,26.08,0,0,0-1.69,7.78,15.45,15.45,0,0,1-.21,3c-.11,0-.41-1-.52-3A22.61,22.61,0,0,1,519.2,222,24.41,24.41,0,0,1,526,211.7a23,23,0,0,1,2.86-2.23,25.09,25.09,0,0,1,7-3.22,27.08,27.08,0,0,1,4-.79,26.11,26.11,0,0,1,4-.13,25,25,0,0,1,3.91.5,24.84,24.84,0,0,1,6.93,2.58,25.32,25.32,0,0,1,5.35,4,24.58,24.58,0,0,1,3.61,4.54,22.4,22.4,0,0,1,3,7.74C567,226.62,567,227.71,566.86,227.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.63,244.72l.41,4.21-3.76.37-.4-4.1c-3.75.13-7.44-.68-9.67-2.1l1.62-4.8a15.21,15.21,0,0,0,7.57,2l-.62-6.29c-4.27-.61-9.08-1.55-9.6-6.93-.39-4,2.18-7.7,8.06-9l-.41-4.18,3.76-.37.4,4.1a17.18,17.18,0,0,1,7.87,1.55L550.43,224a15.37,15.37,0,0,0-5.95-1.4l.62,6.4c4.27.57,9,1.52,9.52,6.82C555,239.76,552.47,243.43,546.63,244.72Zm-5.38-16.27-.53-5.35c-2,.65-2.63,1.82-2.51,3.06S539.54,228.08,541.25,228.45Zm7.35,8.44c-.12-1.32-1.29-1.93-3-2.34l.51,5.2C548,239.15,548.72,238.09,548.6,236.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.57,167.44a24.27,24.27,0,1,1-32.09-12A24.23,24.23,0,0,1,454.57,167.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.31,169.82a18.49,18.49,0,1,1-24.46-9.16A18.47,18.47,0,0,1,449.31,169.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.07,169.3c-.1,0-.51-.66-1.37-1.82a19.6,19.6,0,0,0-4.28-4.28,18.54,18.54,0,0,0-3.62-2,18.14,18.14,0,0,0-4.57-1.28,17.93,17.93,0,0,0-2.56-.19,17.63,17.63,0,0,0-5.37.81,19.21,19.21,0,0,0-2.65,1,18.76,18.76,0,0,0-2.46,1.46,18.27,18.27,0,0,0-2.13,1.76,17.46,17.46,0,0,0-1.78,2,16.88,16.88,0,0,0-1.42,2.14,18.39,18.39,0,0,0-1.78,4.4,19.2,19.2,0,0,0-.59,4.12,19.8,19.8,0,0,0,.78,6,10.2,10.2,0,0,1,.61,2.2,5.73,5.73,0,0,1-1.13-2,17.34,17.34,0,0,1-1.26-6.18,18.76,18.76,0,0,1,.45-4.39,18.43,18.43,0,0,1,1.78-4.75A16.58,16.58,0,0,1,417.2,166a16.77,16.77,0,0,1,1.89-2.18,18.62,18.62,0,0,1,2.29-1.92,21.68,21.68,0,0,1,2.64-1.58,21.09,21.09,0,0,1,2.87-1.13,18.74,18.74,0,0,1,5.79-.81,17.46,17.46,0,0,1,2.75.25,18.8,18.8,0,0,1,4.86,1.5A18.48,18.48,0,0,1,444,162.4a17.09,17.09,0,0,1,4.13,4.77A5.6,5.6,0,0,1,449.07,169.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.93,186.64l1.37,2.91-2.6,1.23-1.34-2.84a13.53,13.53,0,0,1-7.45,1l-.07-3.85a11.63,11.63,0,0,0,5.92-.53l-2.05-4.34c-3.21.66-6.89,1.21-8.65-2.51-1.29-2.75-.41-6.06,3.48-8.47l-1.36-2.89,2.61-1.22,1.33,2.83a13.15,13.15,0,0,1,6-.9l.21,3.82a11.68,11.68,0,0,0-4.62.52l2.08,4.42c3.21-.68,6.83-1.21,8.56,2.45C443.65,181,442.78,184.22,438.93,186.64Zm-8-10.28-1.74-3.69c-1.23,1-1.42,2-1,2.83S429.6,176.54,430.91,176.36Zm7.43,4.17c-.43-.91-1.42-1.05-2.72-.92l1.69,3.59C438.48,182.31,438.73,181.36,438.34,180.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,58.77a20.84,20.84,0,1,1-27.56-10.33A20.81,20.81,0,0,1,511,58.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.5,60.81a15.88,15.88,0,1,1-21-7.87A15.86,15.86,0,0,1,506.5,60.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.29,60.36c-.08,0-.43-.56-1.17-1.56a16.19,16.19,0,0,0-6.78-5.44,15.64,15.64,0,0,0-3.93-1.1,15.82,15.82,0,0,0-2.2-.16,14.89,14.89,0,0,0-2.29.17,16.11,16.11,0,0,0-2.32.52,18.35,18.35,0,0,0-2.28.91A17.75,17.75,0,0,0,483.21,55a15.06,15.06,0,0,0-1.83,1.52,14.41,14.41,0,0,0-1.53,1.71A16.28,16.28,0,0,0,478.63,60a16,16,0,0,0-1.53,3.78,16.65,16.65,0,0,0-.5,3.54,16.89,16.89,0,0,0,.67,5.15,9.73,9.73,0,0,1,.53,1.89,4.65,4.65,0,0,1-1-1.73,14.92,14.92,0,0,1-1.08-5.32,15.88,15.88,0,0,1,1.91-7.85,16,16,0,0,1,1.27-2,15.73,15.73,0,0,1,1.63-1.86,16.67,16.67,0,0,1,2-1.66,18.48,18.48,0,0,1,2.28-1.35,17.57,17.57,0,0,1,2.45-1,16.37,16.37,0,0,1,2.51-.55,16,16,0,0,1,2.47-.15,15.35,15.35,0,0,1,2.37.22A15.87,15.87,0,0,1,502,54.44a14.64,14.64,0,0,1,3.55,4.1A4.54,4.54,0,0,1,506.29,60.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.59,75.25l1.18,2.51-2.24,1-1.14-2.44a11.74,11.74,0,0,1-6.41.84l-.05-3.31a10,10,0,0,0,5.08-.45l-1.76-3.73c-2.76.56-5.92,1-7.43-2.16-1.11-2.37-.35-5.21,3-7.27l-1.17-2.48,2.24-1.06L490,59.19a11.15,11.15,0,0,1,5.18-.77l.18,3.27a10.18,10.18,0,0,0-4,.45l1.79,3.8c2.75-.59,5.87-1,7.35,2.1C501.65,70.37,500.9,73.18,497.59,75.25Zm-6.89-8.82-1.49-3.17c-1.06.82-1.22,1.69-.88,2.43S489.57,66.58,490.7,66.43ZM497.08,70c-.37-.79-1.21-.9-2.33-.79l1.45,3.09C497.2,71.53,497.42,70.72,497.08,70Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.29,284.63a12.82,12.82,0,0,1,3.12-1.35l.64-3.09,5.21-.09.75,3.06a12.74,12.74,0,0,1,3.16,1.24l2.64-1.72,3.75,3.62L700.92,289a12.68,12.68,0,0,1,1.36,3.12l3.08.64.09,5.21-3.06.75a12.51,12.51,0,0,1-1.24,3.16l1.73,2.63-3.62,3.75-2.7-1.63a12.62,12.62,0,0,1-3.11,1.36l-.64,3.08-5.21.09-.75-3.06a12.81,12.81,0,0,1-3.17-1.24l-2.63,1.72L677.3,305l1.63-2.69a13,13,0,0,1-1.35-3.11l-3.08-.65-.1-5.21,3.06-.75a12.93,12.93,0,0,1,1.25-3.16L677,286.75,680.6,283l2.69,1.63Zm2.78,6.94a5.59,5.59,0,1,0,7.91-.14A5.6,5.6,0,0,0,686.07,291.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.41,73.16A23,23,0,0,1,675,70.74l1.15-5.51,9.31-.16,1.34,5.46a23.33,23.33,0,0,1,5.65,2.23l4.7-3.09,6.7,6.47L700.91,81a23.06,23.06,0,0,1,2.42,5.57l5.51,1.15L709,97l-5.47,1.34a22.68,22.68,0,0,1-2.22,5.64l3.09,4.71-6.47,6.7-4.81-2.92a22.67,22.67,0,0,1-5.57,2.42l-1.15,5.51-9.31.17-1.34-5.47a22.9,22.9,0,0,1-5.65-2.22l-4.7,3.08-6.7-6.47,2.92-4.81a22.51,22.51,0,0,1-2.42-5.57L653.69,98l-.17-9.31L659,87.3a22.9,22.9,0,0,1,2.22-5.65l-3.08-4.71,6.47-6.7,4.81,2.92Zm5,12.4a10,10,0,1,0,14.12-.24A10,10,0,0,0,674.37,85.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.74,132.15a12.14,12.14,0,0,1,3-1.29l.61-2.92,4.94-.09.72,2.9a12.19,12.19,0,0,1,3,1.19l2.5-1.64,3.56,3.43-1.55,2.56a12.31,12.31,0,0,1,1.29,3l2.92.61.09,4.95-2.9.71a11.89,11.89,0,0,1-1.19,3l1.64,2.5-3.43,3.56L673.34,153a11.93,11.93,0,0,1-3,1.29l-.61,2.93-4.95.08-.71-2.9a12.24,12.24,0,0,1-3-1.18l-2.5,1.63-3.56-3.43,1.55-2.56a11.77,11.77,0,0,1-1.29-3l-2.93-.61-.08-4.94,2.9-.72a12.56,12.56,0,0,1,1.18-3l-1.64-2.5,3.44-3.56,2.56,1.55Zm2.64,6.59a5.31,5.31,0,1,0,7.5-.13A5.31,5.31,0,0,0,663.38,138.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.85,68.55a11.93,11.93,0,0,1,3-1.29l.61-2.93,5-.08.71,2.9a12.24,12.24,0,0,1,3,1.18l2.5-1.64,3.56,3.44-1.55,2.56a11.77,11.77,0,0,1,1.29,3l2.93.61.08,4.94-2.9.72a12.56,12.56,0,0,1-1.18,3l1.64,2.5L124,91l-2.56-1.55a12.11,12.11,0,0,1-3,1.28l-.61,2.93-4.94.09-.72-2.91a11.78,11.78,0,0,1-3-1.18l-2.5,1.64-3.56-3.43,1.55-2.56a12.28,12.28,0,0,1-1.28-3l-2.93-.61-.09-5,2.91-.71a11.5,11.5,0,0,1,1.18-3l-1.64-2.5L106.29,67l2.56,1.55Zm2.64,6.59A5.31,5.31,0,1,0,119,75,5.31,5.31,0,0,0,111.49,75.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,408.11a12.28,12.28,0,0,1,3-1.28l.61-2.93,4.95-.09.71,2.91a11.5,11.5,0,0,1,3,1.18l2.5-1.64,3.56,3.43-1.55,2.56a11.93,11.93,0,0,1,1.29,3l2.93.61.08,4.95-2.9.71a12.24,12.24,0,0,1-1.18,3L87.4,427,84,430.54,81.4,429a11.77,11.77,0,0,1-3,1.29l-.61,2.93-4.94.08-.72-2.9a12.56,12.56,0,0,1-3-1.18l-2.5,1.64-3.56-3.44,1.55-2.56a12.11,12.11,0,0,1-1.28-3l-2.93-.61-.09-4.94,2.91-.72a11.78,11.78,0,0,1,1.18-3l-1.64-2.5,3.43-3.56,2.56,1.55Zm2.64,6.59a5.31,5.31,0,1,0,7.51-.13A5.31,5.31,0,0,0,71.44,414.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.5,400.32a15.76,15.76,0,0,1,4-1.73l.82-3.95,6.66-.11.95,3.91A16.09,16.09,0,0,1,616,400l3.36-2.21,4.79,4.63L622,405.89a16.68,16.68,0,0,1,1.73,4l3.94.82.11,6.66-3.91,1a16.17,16.17,0,0,1-1.59,4l2.21,3.36-4.62,4.79-3.45-2.08a16.51,16.51,0,0,1-4,1.73l-.82,3.94-6.66.12-1-3.91a17,17,0,0,1-4-1.59l-3.36,2.2-4.79-4.62,2.08-3.44a16.57,16.57,0,0,1-1.73-4l-3.94-.82-.11-6.66,3.91-.95a15.88,15.88,0,0,1,1.59-4L591.43,403l4.62-4.79,3.45,2.09Zm3.55,8.87a7.14,7.14,0,1,0,10.1-.18A7.13,7.13,0,0,0,603.05,409.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.39,103.11a23.92,23.92,0,0,1,5.72-2.49L76.29,95l9.56-.17,1.38,5.62A23.25,23.25,0,0,1,93,102.69l4.83-3.17,6.88,6.65-3,4.94a23.49,23.49,0,0,1,2.48,5.72L109.9,118l.17,9.57L104.45,129a23.25,23.25,0,0,1-2.28,5.81l3.17,4.83-6.64,6.88-5-3A23.33,23.33,0,0,1,88,146l-1.18,5.67-9.56.16-1.38-5.61a23.6,23.6,0,0,1-5.8-2.29l-4.84,3.17-6.88-6.64,3-4.95a22.83,22.83,0,0,1-2.49-5.72l-5.66-1.17L53.07,119l5.62-1.38a23.33,23.33,0,0,1,2.28-5.8L57.8,107l6.65-6.88,4.94,3Zm5.1,12.74A10.27,10.27,0,1,0,89,115.6,10.26,10.26,0,0,0,74.49,115.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63,49c0-5,3-8.23,7.31-8.23s7.28,3.16,7.28,8.23-3,8.23-7.28,8.23S227.63,54,227.63,49ZM238,49c0-3.2-1.22-4.73-3.08-4.73s-3.07,1.58-3.07,4.73,1.27,4.73,3.07,4.73S238,52.21,238,49Zm14.46-7.88h5L237.38,71h-5Zm-4.83,21.95c0-5,3-8.23,7.27-8.23s7.32,3.2,7.32,8.23-3,8.22-7.32,8.22S247.65,68.11,247.65,63.08Zm10.34,0c0-3.16-1.22-4.73-3.07-4.73s-3.07,1.53-3.07,4.73,1.26,4.73,3.07,4.73S258,66.23,258,63.08Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.18,464.45c0,.14-126.79.26-283.17.26s-283.19-.12-283.19-.26,126.77-.26,283.19-.26S658.18,464.31,658.18,464.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588,409.87a10.21,10.21,0,0,1,5.28,6A17.94,17.94,0,0,1,594,424c-.59,5.26-3.58,10.57-6.8,14.77-4.41-3.85-5.47-10.85-5.75-14.06-.48-5.46,2-15.62,6.57-14.8",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.37,447.33a8.7,8.7,0,0,1,2.81-8.27,11.56,11.56,0,0,1,8.51-2.66,4.86,4.86,0,0,1,3.74,1.68,3.71,3.71,0,0,1,.06,3.77,7.49,7.49,0,0,1-2.79,2.74c-3.84,2.41-8,4-12.33,2.74",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.69,463.54a5.58,5.58,0,0,1,.15-1.08l.54-2.92a30.44,30.44,0,0,1,3-9.33,18.71,18.71,0,0,1,6.69-7.12,13.35,13.35,0,0,1,2.73-1.21c.34-.11.61-.15.79-.2a.85.85,0,0,1,.28,0,20.57,20.57,0,0,0-3.66,1.68,19.31,19.31,0,0,0-6.5,7.07,32.67,32.67,0,0,0-3.08,9.2c-.27,1.23-.49,2.22-.66,2.9A7.22,7.22,0,0,1,586.69,463.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.85,417.77a1.39,1.39,0,0,1,.06.47c0,.35.05.8.08,1.35.06,1.18.13,2.89.2,5,.13,4.22.24,10,.21,16.48s-.18,12.26-.35,16.47c-.09,2.11-.17,3.81-.25,5,0,.56-.07,1-.09,1.36a1.54,1.54,0,0,1-.06.47,2.58,2.58,0,0,1,0-.48c0-.35,0-.8,0-1.36,0-1.22.07-2.91.12-5,.11-4.21.22-10,.25-16.46s0-12.26-.1-16.47c0-2.07-.06-3.77-.08-5,0-.56,0-1,0-1.36A2.42,2.42,0,0,1,586.85,417.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.7,450.53a20.3,20.3,0,0,0-11.1-14.9c-1.48-.71-3.42-1.18-4.63-.08s-1,3.09-.35,4.62a17.38,17.38,0,0,0,16,10.79",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.31,440.7a5.18,5.18,0,0,1,.94.41,9.72,9.72,0,0,1,1.07.57c.39.24.87.49,1.35.84s1,.71,1.54,1.17a20.18,20.18,0,0,1,1.65,1.49,23,23,0,0,1,3.13,4,22.62,22.62,0,0,1,2.06,4.66,20.5,20.5,0,0,1,.52,2.17,16.5,16.5,0,0,1,.27,1.91,15.59,15.59,0,0,1,.07,1.6,8.74,8.74,0,0,1,0,1.2,4.45,4.45,0,0,1-.11,1c-.09,0,.06-1.46-.19-3.79a18.81,18.81,0,0,0-.31-1.88,19.56,19.56,0,0,0-.55-2.12,22.78,22.78,0,0,0-2.05-4.57,23.59,23.59,0,0,0-3-4,21.7,21.7,0,0,0-1.6-1.5c-.51-.46-1-.83-1.5-1.18C575.61,441.38,574.27,440.77,574.31,440.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Business--inject-19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 655.9,
    cy: 351.33,
    r: 34.02,
    transform: "translate(-56.32 566.7) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615.74 322.64 637.65 323.19 626.97 311.89 615.74 322.64",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 618.2,
    y: 322.91,
    width: 16.13,
    height: 33.99,
    transform: "translate(8.68 -15.53) rotate(1.43)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.42,334.65c-.31.06-.87-1.26-1.55-3.55l0,.06a4.15,4.15,0,0,0-2.82-2.74,6,6,0,0,0-1.29-.06h-1.63l-3.46-.06-3.14-.1-1.5-.07-.72,0c-.25,0-.49,0-.61,0a4.25,4.25,0,0,0-3.09,2.14,9.76,9.76,0,0,0-.83,1.55c-.23.52-.45,1-.64,1.31-.39.71-.68,1.08-.85,1s-.21-.52-.12-1.32c0-.4.12-.89.22-1.44a8.8,8.8,0,0,1,.59-2,7.1,7.1,0,0,1,1.52-2.2,5.29,5.29,0,0,1,3-1.46,6.37,6.37,0,0,1,.81,0h2.24l3.16.05,3.49.12,1.64.08a7,7,0,0,1,1.81.24,5.15,5.15,0,0,1,2.83,2.05,6.13,6.13,0,0,1,1,2.53l0,.06C667.76,333.15,667.74,334.58,667.42,334.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.33,377.68l1.08-43.29L686,335.88s-.56,43.3-1.08,43.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "625.05 354.92 649.97 360.15 659.6 360.39 687.19 355.65 687.72 334.15 625.61 332.6 625.05 354.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.05,354.92a2,2,0,0,1,0-.37c0-.28,0-.65,0-1.13,0-1,0-2.49.06-4.38.08-3.88.18-9.47.32-16.44v-.18h.18l62.12,1.46H688v.32c-.19,7.41-.37,14.6-.54,21.43v.21l-.2,0-27.59,4.7h0l-9.63-.26h0l-18.26-3.94-4.93-1.08-1.27-.29a2.53,2.53,0,0,1-.42-.11l.46.08,1.31.25,5,1L650,360h0l9.63.21h0l27.57-4.79-.21.24c.17-6.83.35-14,.53-21.43v-.06l.26.26-62.12-1.63.18-.17c-.21,6.93-.38,12.48-.5,16.34-.07,1.9-.12,3.38-.15,4.42,0,.49,0,.87,0,1.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.33,
    y: 357.49,
    width: 10.78,
    height: 5.62,
    rx: 2.06,
    transform: "translate(9.2 -16.26) rotate(1.43)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "674.57 362.82 696.49 363.37 685.81 352.07 674.57 362.82",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 677.16,
    y: 363.09,
    width: 16.13,
    height: 24.08,
    transform: "translate(9.58 -16.99) rotate(1.43)",
    style: {
      fill: "#FF822F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Scales--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "333.71 370.41 263.06 139.53 182.21 369.44 181.27 369.11 263.13 136.33 334.66 370.12 333.71 370.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,376.39C235,370.67,232,354.94,232.42,343s6.54-23.29,15.21-31.55,19.69-13.7,31.07-17.42l14.13,2.68s33.88,38.51,34.67,57.79c.48,11.74-6.9,21.91-6.9,21.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,376.39h.36l1,0,4,0,15.29-.06,54.34-.1-.18.1a41.67,41.67,0,0,0,6.2-14.55,28.94,28.94,0,0,0,.53-8.33,33.22,33.22,0,0,0-2.16-8.33,98.25,98.25,0,0,0-8.29-16c-3.25-5.23-6.86-10.39-10.68-15.51-4.37-5.83-8.85-11.42-13.39-16.67l.15.08-14.13-2.68h.13a93.92,93.92,0,0,0-20.64,9.39,60,60,0,0,0-15.55,13.67,47.73,47.73,0,0,0-8.5,16.36,45.24,45.24,0,0,0-1.38,15.82,52.48,52.48,0,0,0,2.4,12.78,30.5,30.5,0,0,0,4.38,8.65c.42.52.77,1,1.18,1.46l1.14,1.19c.75.69,1.43,1.23,2,1.66l1.32.86.44.3-.46-.26-1.35-.83c-.56-.42-1.25-.95-2-1.63l-1.16-1.18c-.42-.42-.78-.95-1.21-1.46a30.82,30.82,0,0,1-4.48-8.68,52.34,52.34,0,0,1-2.48-12.84,45.4,45.4,0,0,1,1.33-15.94A48.19,48.19,0,0,1,242.25,317a60.63,60.63,0,0,1,15.63-13.81,94.85,94.85,0,0,1,20.74-9.46l.06,0h.07l14.12,2.67.09,0,.06.07c4.56,5.26,9,10.86,13.41,16.69,3.83,5.14,7.45,10.31,10.71,15.56a98,98,0,0,1,8.32,16.1,33.33,33.33,0,0,1,2.18,8.47,29.09,29.09,0,0,1-.55,8.46,42.2,42.2,0,0,1-6.3,14.73l-.07.09h-.12l-54.39-.1-15.27-.06-4,0-1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,292s-14.21-30.75-13.28-31.68,6.33-4.85,6.33-4.85-3.35-5-.18-6.33,26.65-3.73,34.85,6.15a21.27,21.27,0,0,1-2.8,17.52c-5.8,8.93-12.67,22-12.67,22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,292l.22,0,.62.13,2.4.51,9,2-.16.07c2.31-4.4,5.35-10,9.12-16.39.95-1.59,1.94-3.24,3-4.9.54-.84,1-1.69,1.53-2.57l.66-1.36c.2-.47.37-1,.56-1.43a20.88,20.88,0,0,0,.48-12.71l0,.08a15.33,15.33,0,0,0-2.65-2.43,21.5,21.5,0,0,0-3.21-1.83,32.12,32.12,0,0,0-7.28-2.18,59.91,59.91,0,0,0-14.93-.68c-1.2.09-2.39.22-3.55.39-.59.09-1.16.19-1.73.31a4.63,4.63,0,0,0-1.56.53,1.82,1.82,0,0,0-.82,1.23,4.11,4.11,0,0,0,.12,1.59,10.85,10.85,0,0,0,1.34,3l.12.19-.18.14-3.7,2.72-1.76,1.36a9.17,9.17,0,0,0-.81.69c0-.06,0,.16,0,.31s.07.34.11.51c.83,2.71,1.93,5.24,2.89,7.61,2,4.75,3.81,8.89,5.31,12.31s2.7,6.09,3.54,8c.39.9.7,1.61.93,2.11l.23.55c.05.13.07.19.06.19a.65.65,0,0,1-.1-.17l-.27-.53c-.23-.5-.57-1.2-1-2.09l-3.66-7.91c-1.54-3.41-3.4-7.53-5.41-12.27-1-2.39-2.09-4.88-2.95-7.65a4.9,4.9,0,0,1-.13-.55,2.43,2.43,0,0,1,0-.3,1.37,1.37,0,0,1,0-.19.56.56,0,0,1,.07-.16l.06-.06c.28-.27.57-.49.85-.73.58-.46,1.17-.91,1.77-1.37l3.69-2.74-.05.32a11.21,11.21,0,0,1-1.42-3.1,4.5,4.5,0,0,1-.13-1.8,2.3,2.3,0,0,1,1-1.56,5.2,5.2,0,0,1,1.72-.6c.59-.13,1.17-.23,1.76-.32q1.77-.26,3.6-.39a59.93,59.93,0,0,1,15.05.66,33,33,0,0,1,7.4,2.23,21.82,21.82,0,0,1,3.3,1.88,16.47,16.47,0,0,1,2.75,2.52l0,0v0a21.31,21.31,0,0,1-.51,13c-.19.49-.37,1-.58,1.46s-.45.93-.68,1.39c-.5.89-1,1.77-1.55,2.59-1.07,1.66-2.07,3.3-3,4.88-3.8,6.35-6.87,11.94-9.23,16.31l-.05.1-.11,0-9.06-2.14-2.36-.58-.6-.15C280,292,280,292,280,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.94 294.42 277.87 288.69 293.69 292.43 293.15 296.97 276.94 294.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.16,350.62l0,3.58-2.62,0,0-3.54c-3.13-.23-6.15-1.28-7.8-2.74l1.47-3.21a12.35,12.35,0,0,0,6.37,2.5l.07-6.4c-3.54-.9-7.33-2.09-7.28-6.53,0-3.26,2.43-6.08,7.42-6.5l0-3.61,2.62,0,0,3.55a13.61,13.61,0,0,1,6.46,2l-1.34,3.21a13.2,13.2,0,0,0-5.16-1.78l-.07,6.46c3.54.9,7.4,2.06,7.35,6.5C289.61,347.38,287.19,350.16,282.16,350.62Zm-2.47-13.7.06-5.69c-2.27.33-3.24,1.47-3.26,2.87S277.84,336.36,279.69,336.92Zm5.86,7.44c0-1.56-1.38-2.31-3.29-2.88l-.06,5.66C284.54,346.81,285.54,345.74,285.55,344.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.92,324.9a18.71,18.71,0,1,1-24.4-10.22A18.71,18.71,0,0,1,268.92,324.9Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.52,314.68a18.71,18.71,0,0,0-10.23,24.4s12.39-4.44,13.31-10.54S244.52,314.68,244.52,314.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.38,326.44a14.22,14.22,0,1,1-18.55-7.77A14.22,14.22,0,0,1,264.38,326.44Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.38,326.44a14.22,14.22,0,1,1-18.55-7.77A14.22,14.22,0,0,1,264.38,326.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265,326.84a14,14,0,1,1-18.3-7.67A14,14,0,0,1,265,326.84Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265,326.84a14,14,0,1,1-18.3-7.67A14,14,0,0,1,265,326.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.05,330.81l-1.36-3.32h0a7.73,7.73,0,0,1,2-.26,6.26,6.26,0,0,1,1,.19v-.13l0-1.4v-.32l-.85-.38-.23.24a6.68,6.68,0,0,0-2.69.29l-.75-1.83-.76-.22.19.46-.78.32.76,1.86c-2.46,1.29-3.08,3.26-2.39,4.94.93,2.28,3.13,2.08,5.14,1.77l1.35,3.29a6.78,6.78,0,0,1-3.8.1l-.06,2a7.81,7.81,0,0,0,4.59-.29l.56,1.38-.64.27.82.18,1.35-.55-.75-1.85c2.48-1.32,3.12-3.27,2.43-4.95C256.28,330.27,254.06,330.51,252.05,330.81Zm-1.49.21c-1.07.11-1.93,0-2.25-.75s-.05-1.52,1.05-2.18Zm.13-3.53Zm3.37,8.23-1.2-2.92c1.11-.12,2,0,2.31.77S255.18,335.05,254.06,335.72Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.05,330.81l-1.36-3.32h0a7.73,7.73,0,0,1,2-.26,6.26,6.26,0,0,1,1,.19v-.13l0-1.4v-.32l-.85-.38-.23.24a6.68,6.68,0,0,0-2.69.29l-.75-1.83-.76-.22.19.46-.78.32.76,1.86c-2.46,1.29-3.08,3.26-2.39,4.94.93,2.28,3.13,2.08,5.14,1.77l1.35,3.29a6.78,6.78,0,0,1-3.8.1l-.06,2a7.81,7.81,0,0,0,4.59-.29l.56,1.38-.64.27.82.18,1.35-.55-.75-1.85c2.48-1.32,3.12-3.27,2.43-4.95C256.28,330.27,254.06,330.51,252.05,330.81Zm-1.49.21c-1.07.11-1.93,0-2.25-.75s-.05-1.52,1.05-2.18Zm.13-3.53Zm3.37,8.23-1.2-2.92c1.11-.12,2,0,2.31.77S255.18,335.05,254.06,335.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M254.05,337.29l.75,1.84-1.35.56-.75-1.83a7.79,7.79,0,0,1-4.59.28l.06-2a6.81,6.81,0,0,0,3.81-.1l-1.35-3.29c-2,.3-4.21.51-5.15-1.78-.69-1.68-.07-3.64,2.4-4.94l-.76-1.86,1.35-.55.75,1.83a7.55,7.55,0,0,1,3.75-.37v1.94a7.57,7.57,0,0,0-3,.2l1.36,3.33c2-.3,4.24-.54,5.18,1.74C257.17,334,256.52,336,254.05,337.29Zm-4.24-6.49-1.2-2.93c-1.09.66-1.34,1.45-1.05,2.18S248.74,330.91,249.81,330.8Zm4.62,2.55c-.33-.81-1.21-.89-2.31-.77l1.19,2.92C254.44,334.82,254.72,334.05,254.43,333.35Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.17,331.93a1.32,1.32,0,0,1-.54-.22,2.31,2.31,0,0,1-.88-1.1,2.25,2.25,0,0,1,0-1.4,1.18,1.18,0,0,1,.27-.52s-.09.2-.17.54a2.26,2.26,0,0,0,.88,2.39C247,331.83,247.18,331.91,247.17,331.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.05,325.69s-.17-.22-.29-.52a1.45,1.45,0,0,1-.16-.57s.17.22.29.52A1.45,1.45,0,0,1,248.05,325.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88,317.84a4.06,4.06,0,0,1-.43.16l-.5.17c-.2.08-.42.15-.66.26s-.51.22-.78.36-.56.29-.87.46a15.73,15.73,0,0,0-1.85,1.27,16.43,16.43,0,0,0-1.64,1.54c-.23.26-.46.5-.64.75s-.37.47-.52.68-.28.42-.39.59-.21.33-.29.45a3.15,3.15,0,0,1-.24.39,2.53,2.53,0,0,1,.2-.41,4.88,4.88,0,0,1,.26-.47c.11-.18.23-.39.38-.6s.31-.46.51-.7.4-.5.63-.76a14.71,14.71,0,0,1,1.65-1.57,15.17,15.17,0,0,1,1.88-1.27c.31-.17.6-.33.88-.45s.55-.25.79-.35.47-.17.67-.24l.52-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.6,
    y: 349.63,
    width: 35.56,
    height: 6.9,
    transform: "translate(494.77 706.15) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.88,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.58,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.32,349.74a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.12,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.88,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.63,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.39,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.89,
    y: 356.53,
    width: 35.56,
    height: 6.9,
    transform: "translate(499.34 719.95) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.16,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,356.64a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.37,356.64a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.88,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.64,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.92,356.64a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68,356.64a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,356.55c0,.09,8,.15,17.75.15s17.75-.06,17.75-.15-7.95-.15-17.75-.15S231.88,356.46,231.88,356.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.86,
    y: 363.33,
    width: 35.56,
    height: 6.9,
    transform: "translate(495.27 733.56) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.13,363.44a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.57,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.85,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.61,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,363.44a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,363.44a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.89,363.44a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.65,363.44a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,363.35c0,.09,8,.16,17.75.16s17.74-.07,17.74-.16-7.94-.15-17.74-.15S229.85,363.27,229.85,363.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 229.6,
    y: 349.63,
    width: 35.56,
    height: 6.9,
    transform: "translate(494.77 706.15) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 231.89,
    y: 356.53,
    width: 35.56,
    height: 6.9,
    transform: "translate(499.34 719.95) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 229.86,
    y: 363.33,
    width: 35.56,
    height: 6.9,
    transform: "translate(495.27 733.56) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 204.87,
    y: 313.94,
    width: 35.56,
    height: 7.17,
    transform: "translate(445.3 635.06) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,314.06a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.85,314.06a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.59,314.06a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.35,314.06a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.11,314.06a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,314.06a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,314.06a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.38,314.06a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.14,314.06a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9,314.06a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.66,314.06a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.91,
    y: 321.23,
    width: 35.56,
    height: 7.17,
    transform: "translate(439.38 649.63) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.18,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.63,321.35a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39,321.35a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.14,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.9,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.66,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.42,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.18,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.94,321.35a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7,321.35a40.33,40.33,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.9,321.24a129.63,129.63,0,0,1-34.42,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,321.25c0,.09,7.95.16,17.75.16s17.75-.07,17.75-.16-8-.15-17.75-.15S201.9,321.17,201.9,321.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.53,
    y: 328.52,
    width: 35.56,
    height: 7.17,
    transform: "translate(442.62 664.22) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8,328.64a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.5,328.64a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.25,328.64a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,328.64a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.76,328.64a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,328.64a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.28,328.64a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,328.64a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.8,328.64a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56,328.64a40.33,40.33,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.32,328.64a40.33,40.33,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.52,328.53a129.63,129.63,0,0,1-34.42,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M203.52,328.55c0,.08,7.95.15,17.75.15s17.75-.07,17.75-.15-8-.16-17.75-.16S203.52,328.46,203.52,328.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.73,
    y: 335.57,
    width: 35.56,
    height: 7.17,
    transform: "translate(441.02 678.32) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,335.69a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.71,335.69a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.45,335.69a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.21,335.69a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,335.69a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.73,335.69a37.93,37.93,0,0,0,0,7,40.44,40.44,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,335.69a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.24,335.69a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,335.69a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,335.69a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.52,335.69a40.44,40.44,0,0,0,0,7,37.92,37.92,0,0,0,0-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.72,335.58a129.63,129.63,0,0,1-34.42,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M202.72,335.6c0,.08,7.95.15,17.75.15s17.75-.07,17.75-.15-7.95-.16-17.75-.16S202.72,335.51,202.72,335.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.11,
    y: 342.51,
    width: 35.56,
    height: 7.17,
    transform: "translate(447.77 692.19) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,342.63a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.08,342.63a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.82,342.63a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.58,342.63a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.34,342.63a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.1,342.63a40.33,40.33,0,0,0,0,6.95,37.82,37.82,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.86,342.63a40.33,40.33,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,342.63a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.38,342.63a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.14,342.63a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,342.63a37.82,37.82,0,0,0,0,6.95,40.33,40.33,0,0,0,0-6.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.09,342.52a129.56,129.56,0,0,1-34.41,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.1,342.53c0,.09,7.94.16,17.74.16s17.75-.07,17.75-.16-7.94-.15-17.75-.15S206.1,342.45,206.1,342.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.94,
    y: 349.63,
    width: 35.56,
    height: 6.9,
    transform: "translate(439.44 706.15) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.92,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.66,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.18,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.94,349.74a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.45,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.21,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.73,349.74a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.93,349.64a102,102,0,0,1-34.42,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M201.93,349.65c0,.09,7.95.15,17.75.15s17.75-.06,17.75-.15-8-.15-17.75-.15S201.93,349.57,201.93,349.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.23,
    y: 356.53,
    width: 35.56,
    height: 6.9,
    transform: "translate(444.01 719.95) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.5,356.64a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.2,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.94,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,356.64a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,356.64a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5,356.64a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26,356.64a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,356.64a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M239.21,356.54a90.12,90.12,0,0,1-34.41,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M204.22,356.55c0,.09,7.95.15,17.75.15s17.74-.06,17.74-.15-7.94-.15-17.74-.15S204.22,356.46,204.22,356.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.2,
    y: 363.33,
    width: 35.56,
    height: 6.9,
    transform: "translate(439.95 733.56) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.47,363.44a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.17,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.67,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.43,363.44a37.37,37.37,0,0,0,0,6.69,35,35,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,363.44a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,363.44a37.37,37.37,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.71,363.44a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,363.44a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,363.44a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,363.44a35,35,0,0,0,0,6.69,37.37,37.37,0,0,0,0-6.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.18,363.34a101.93,101.93,0,0,1-34.41,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M202.19,363.35c0,.09,7.94.16,17.74.16s17.75-.07,17.75-.16-7.94-.15-17.75-.15S202.19,363.27,202.19,363.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.59,349.68a.6.6,0,0,1,0-.13c0-.09,0-.22,0-.37,0-.34,0-.82,0-1.42,0-1.26,0-3.05,0-5.25l.08.09-3.45-.05h-.09v-.1c0-2.05,0-4.32,0-6.75v-.11H239l-.12.11V328.4l.12.12h-1.74v-.12c0-2.64,0-5.1,0-7.29V321h.1l3,0-.09.08c0-2.19.07-4,.09-5.24,0-.6,0-1.08,0-1.43,0-.15,0-.27,0-.37s0-.13,0-.13a.89.89,0,0,1,0,.13c0,.1,0,.22,0,.37,0,.35,0,.83,0,1.43,0,1.26,0,3.05,0,5.25v.08h-3l.1-.1c0,2.19,0,4.65,0,7.29l-.11-.12h1.73v7.53h-.91l.11-.12c0,2.43,0,4.7,0,6.75l-.1-.1,3.45.08h.08v.08c0,2.2-.07,4-.09,5.25,0,.6,0,1.08,0,1.42v.38C241.6,349.64,241.6,349.68,241.59,349.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.74,369.27s18.71,20.87,50.15,20.88,58.51,0,58.51,0,30.05-1.77,43.78-19.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,255.43a6.78,6.78,0,0,1,.9,1.21c.25.45.53,1,.84,1.54s.63,1.33,1,2.12A133.7,133.7,0,0,1,280.19,273c1.53,5,2.75,9.62,3.55,13,.4,1.67.69,3,.87,4a8,8,0,0,1,.2,1.48,8.38,8.38,0,0,1-.4-1.44c-.27-1-.61-2.34-1-3.93-.89-3.32-2.16-7.89-3.69-12.9s-3-9.51-4.31-12.69l-.9-2.13c-.28-.59-.54-1.11-.76-1.57A8.75,8.75,0,0,1,273,255.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.84,271.8a24.23,24.23,0,0,1-1.08,3.19c-.7,1.95-1.63,4.66-2.53,7.7s-1.58,5.82-2.05,7.84a25.33,25.33,0,0,1-.82,3.27,3.29,3.29,0,0,1,.07-.91c.07-.57.2-1.41.39-2.43.38-2,1-4.86,1.91-7.92a78.31,78.31,0,0,1,2.69-7.68c.39-1,.73-1.74,1-2.26A3.44,3.44,0,0,1,293.84,271.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7,302.17a10.77,10.77,0,0,1,1.31-4.05,11.06,11.06,0,0,1,2.34-3.55c.12.09-.87,1.69-1.87,3.78S280.84,302.21,280.7,302.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.24,308.86a6.19,6.19,0,0,1-.5-2,27,27,0,0,1-.32-5A26.2,26.2,0,0,1,288,297a6.76,6.76,0,0,1,.61-2c.16,0-.6,3.08-.7,6.92S288.4,308.83,288.24,308.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.78 374.13 497.14 143.25 416.29 373.16 415.34 372.82 497.2 140.04 568.74 373.84 567.78 374.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.15,
    cy: 325.49,
    r: 63.4,
    transform: "translate(-85.72 444.04) rotate(-45)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M485.94,263.18l-.09,0-.43,0-.48.18s-.06,0-.05,0,.14.13.76,0C486,263.29,486,263.2,485.94,263.18Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M485,262.66a1.87,1.87,0,0,0,.28-.08s0,0,0,0l-.35,0c-.05,0-.1,0-.09,0S484.87,262.67,485,262.66Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M486.94,262.43a1.15,1.15,0,0,0,.32,0l.42,0,.33-.06-.05,0a15.58,15.58,0,0,0-2,.16l.51,0A3.25,3.25,0,0,1,486.94,262.43Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81,262.64h0a1.58,1.58,0,0,1,.42,0l.41,0,.06,0h-.08a7.17,7.17,0,0,0-2.18.28,10.41,10.41,0,0,0,1.36-.12S485.8,262.66,485.81,262.64Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M486.82,262.89l.08,0,.12-.06.23-.09.05,0h0a2.23,2.23,0,0,0-.68.15h0s0,0-.1.12A2.46,2.46,0,0,0,486.82,262.89Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M483.77,263.83l-.06,0h-.19a2.79,2.79,0,0,0-.64.16h0a3.18,3.18,0,0,0,.77-.08C483.73,263.89,483.82,263.85,483.77,263.83Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M483.86,265s0-.05-.17-.08h-.08l-.67-.1a4.27,4.27,0,0,0-1.43.19s0,0,0,0,.15,0,.2.11,0,.14,0,.16a5.81,5.81,0,0,1-.94.3.17.17,0,0,1-.11,0c0-.18.23-.16.28-.3a1.8,1.8,0,0,0-.83.19l0,.05c0,.14,0,.27,0,.4s0,.11,0,.16-.12.15-.14.25v.05c.1.22,1.8-.11,2.32-.36.12-.06.53-.46.37-.51a2,2,0,0,0-.55,0c.41-.11.83-.13,1.24-.24C483.31,265.21,483.84,265,483.86,265Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M479.84,263.5c.71-.06,1.38-.31,2.08-.4a6,6,0,0,0-.78.19l2.46-.44a.62.62,0,0,0,.21-.08.11.11,0,0,0-.08,0,42.54,42.54,0,0,0-4.76.88c.32.07.6-.12.91-.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M478.32,267.83h0a.45.45,0,0,0-.17,0c-.34.11-.63.32-1,.4-.58.13-.76.16-.81.23h0a.71.71,0,0,0,.2,0c.2,0,.22,0,.25.07s0,.17.07.23a1.66,1.66,0,0,0,.3.07,2.34,2.34,0,0,0,1.36-.09c.13-.07.05-.59.05-.59A.73.73,0,0,0,478.32,267.83Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M480.72,264.73a.36.36,0,0,0-.15,0,1.81,1.81,0,0,0-.93.16h0a.37.37,0,0,1,.14,0s0,0-.08.12-.17.16-.06.17a3.67,3.67,0,0,0,.81-.26C480.73,264.83,480.81,264.76,480.72,264.73Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M524.47,277.71c-.22-.65-.72-1.16-.92-1.83a6.09,6.09,0,0,1,0-1.28c0-.49.08-.58.41-.74s.26-.43-.28-1.08c-1.77-2.1-1.78-2.14-1.86-2.5l.07-.08H522c-.43-.87-1.93-.83-1.82-2.15l-.19-.19.12-.17h.09c-.27-.15-1.1-.5-1.11-.5a7.07,7.07,0,0,0-1.46-.38c-.52-.09-.82-.55-1.28-.73-.66-.26-2.11-.77-2.7-.95-1.08-.31-1.08-.31-1.24-.27h0a9.27,9.27,0,0,0-1.78-.44h0l0,0a4.92,4.92,0,0,1,.85.41,6.94,6.94,0,0,1-.82-.29,7.68,7.68,0,0,0-.8-.25,18.42,18.42,0,0,0-5.11-.46c.07.09.07.09.46.22a3.43,3.43,0,0,1-1.74.17,22.48,22.48,0,0,0-2.49,0c-.86.58.52,1.35.54,1.35,3.74,1,3.78,1.07,3.95,1.39,0,0,1.05,2.5.14,3.33-.37.34-.37.35-.38.42,0,.23.22.34.23.55s-.21.61-.15.94c.52.06,1.08-.31,1.56.15a.88.88,0,0,1,.09,1.41c-.57.34-1.29.06-1.84.47a2.49,2.49,0,0,0-.8,1.49c0,.25,1.15,6.07,2.35,7,3.18,1.85,3.28,1.79,3.59,1.62a20.09,20.09,0,0,0,2.23-3.2c.25-.43.18-1,.6-1.36.22-.18.23-.18,1.18-.14,3,.13,3,.13,3.22-.35s.4-.78,1-.85c1.39-.19,2.76.2,4.15,0a12.33,12.33,0,0,0,1.7-.21S524.62,278.16,524.47,277.71Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M489.09,271.51c.27-.32.27-.51,0-.56,0,0-.86-.06-1.12.23s0,.8.09.93C488.3,272.42,489.09,271.52,489.09,271.51Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M498.49,262.46h-.6c.61.07,2.58.21,2.9.23a30.83,30.83,0,0,1-3.51-.19.86.86,0,0,0-.46,0,1.15,1.15,0,0,1-.47.48c-.48-.35-2.17,0-2.24,0,.11.1.26.13.35.24l0,.06a3.56,3.56,0,0,0,.94,0c-1.23.2-1.3,0-1.35-.09-.79-.25-.94,0-1,.16-.55.14-1.14,0-1.67.21a.25.25,0,0,1,0,.07,4,4,0,0,0,1.08.21c.64.1,1.32-.14,1.93.24a.46.46,0,0,1-.26.15c.41.24,2.05.05,2-.34l-.14-.09a5.63,5.63,0,0,1,1.52-.35c1.35.14,2-.18,2-.28l-.06,0a7.78,7.78,0,0,0,2.29,0,.8.8,0,0,0-.3-.07l3.06.11c-.71-.14-.75-.15-1-.22.71.06,1.41.19,2.12.25-.63-.21-1.73-.45-1.74-.45s-2.7-.47-3.31-.45a.29.29,0,0,0,.07.12,1.06,1.06,0,0,1-.47-.13,9.52,9.52,0,0,0-2.85-.14C497.43,262.36,497.46,262.38,498.49,262.46Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M486.81,263.26a2.62,2.62,0,0,1-.21.17,1.91,1.91,0,0,1-.47.19l.17-.19a.86.86,0,0,0,.07-.1.71.71,0,0,0-.56.09l.08,0v0a6.13,6.13,0,0,1-1.05.11s.1,0,.14.05l-.07.07c.05,0,.05,0,1,.06a3.7,3.7,0,0,0-1.27.35h0s1.07,0,1.22,0a6.33,6.33,0,0,0,.79-.29s0,0,0,.08h0c.33-.15.33-.15,1.16-.46.18-.06.19-.07.22-.1l-.09,0s-.93,0-1,0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M493.6,273.17c.41.1.88,1.48.89,1.5.11.34.23.69.43.72.57.09,2.1-1.68,2.11-1.7a.47.47,0,0,0,.11-.21l-3.61-2.27a6.13,6.13,0,0,1,1.36-.18c.48,0,.72,0,.74-.17a4.75,4.75,0,0,0-1.48-2.42c-.28-.15-.63-.17-.87-.42s0-.74-.44-.92a7,7,0,0,0-2-.13c-.69,0-.7,0-.79,0s0-.23.26-1.14a3.83,3.83,0,0,0-1.28-.36c-1.28-.14-5.84,1.57-5.34,2.26s2.92,1,3.28,1c0-.2,0-.34,1.06-.1s1.06,0,1.19-.06a8.13,8.13,0,0,1,.55.83c.18.41.15.87.31,1.29s1,.75.73,1.5c0,0-.76,1.62-3.32,1.5a11.8,11.8,0,0,0-2.3-.22.66.66,0,0,0-.47.64c.09.16.48.36,1.85.37,1.05,0,1.05,0,2.45,1.33-.19.09-.19.09-.94.11.25.45,2.88,2,3.57,1.92,0-.1,0-.1-.11-.22a13.34,13.34,0,0,1-.91-1.68,3.54,3.54,0,0,1,1.64,1.26c.08.12.14.2.2.2.35,0,1.3-1,1.13-1.35-.35-.76-1.4-1.05-1.4-2.05C492.2,273.12,493.59,273.16,493.6,273.17Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M482.74,263.06s.28,0,.5,0l.13,0h0A3,3,0,0,0,482.74,263.06Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M503.21,273.86l.64.09a.41.41,0,0,0,.26-.11.19.19,0,0,0,0-.17c0-.11-.12-.18-.15-.28a.17.17,0,0,1,0-.14v0a.55.55,0,0,0-.28-.12c-.29,0-1.22.14-.89.54A.64.64,0,0,0,503.21,273.86Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M492.65,266.71h0a2.85,2.85,0,0,0-1.43-.78c-.57-.1-.53.32-.44.47C491.09,266.87,492.64,266.71,492.65,266.71Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M489.43,262.41a5.93,5.93,0,0,0-.6,0h.09a1.66,1.66,0,0,1,.55.12c-.06.09-.19,0-.24.13a1.8,1.8,0,0,0,.57,0,2.49,2.49,0,0,0,.91-.39c-.06-.05-.13,0-.2,0,.1-.1.24,0,.35-.11h-.05a10.4,10.4,0,0,0-1.35.08c.1.07.22,0,.32.07S489.71,262.41,489.43,262.41Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M486.27,264.12c-.14,0-.19.05,0,.22a1,1,0,0,0,.95,0c.24-.1.76-.35.59-.43l-.08,0A8.76,8.76,0,0,0,486.27,264.12Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M492.42,263.11h-.09c-.27,0-.54,0-.81,0s-.61-.06-.92-.07h-.41a8.89,8.89,0,0,0,1.41.22,1.53,1.53,0,0,0,.72-.09Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M490.25,262.82v0c.09,0,1.05,0,1.33-.07s.15,0,.17-.07-.07-.05-.05-.1,0-.05,0-.08,0,0,0,0a0,0,0,0,0,0,0,.16.16,0,0,0-.12,0,.47.47,0,0,0-.15,0,2.83,2.83,0,0,1-.67.24C490.45,262.71,490.34,262.71,490.25,262.82Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M492.63,262.25c.69-.09.7-.09.71-.11h-.06s-.67,0-.87,0-.19.12-.19.12A.92.92,0,0,0,492.63,262.25Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M494,262.42c.28,0,.36,0,.44.09l0,0a1.88,1.88,0,0,1-.46,0,6.93,6.93,0,0,0-1,0c-.18,0-.26.22-.21.27s0,0,.5,0c.19,0,.36.12.56.12.47,0,.93-.15,1.4-.19.3,0,.59,0,.88,0l.07,0s0,0-.18-.12v0l.15,0c.4,0,.41-.06.43-.09s-.08,0-.1-.07.22,0,.23-.17.24,0,.34-.12l-.07,0a20,20,0,0,0-2.39,0,.73.73,0,0,0,.25,0,1.67,1.67,0,0,1-.63,0,1.46,1.46,0,0,0-.84.13A3.53,3.53,0,0,0,494,262.42Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M487.74,264.66s4.47,1.08,6,.35c.42-.2-.33-.51-.33-.51a17.45,17.45,0,0,0-3-.14c-.41,0-.57-.41-.47-.47s.11,0,.26,0c.76.05.49-.29.42-.32a3.43,3.43,0,0,0-.55-.06c-.21,0-.38-.19-.59-.24s-.27-.06-.41-.07a1.44,1.44,0,0,0-.61.33.85.85,0,0,0,.29,0c.21,0,.51,0,.55.06s-.41.42-.44.43a8.42,8.42,0,0,0-.86.24C487.47,264.57,487.62,264.62,487.74,264.66Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M480.59,263.43h0c-.16,0-1.48.28-1.56.33S479.15,263.79,480.59,263.43Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M472.82,265.86v0h.08c.44-.11.84-.31,1.28-.43.78-.22,1.58-.34,2.36-.58.18-.05.18-.05.49-.33v0a2.24,2.24,0,0,0-.68.1c.21-.09.21-.09.27-.19l0,0h-.08c-.89.05-.89.05-5.29,1.65a2.78,2.78,0,0,0-1.11.68l0,0A13.2,13.2,0,0,0,472.82,265.86Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M478.74,264.3a2.45,2.45,0,0,0,.72-.07,18.8,18.8,0,0,1,1.89-.27,11.3,11.3,0,0,0,1.16,0c.3-.05,1.52-.38,1.53-.39.23-.06.26-.08.29-.11a.66.66,0,0,0-.32,0c-.36.07-.7.21-1.06.28.49-.24,1-.38,1.52-.63h0a6.14,6.14,0,0,0-1.55.36c-.07.11-.35.37-1.36.26,0,0,0,0,0,0l.1-.05,0,0c.18-.09.64,0,.53-.29,0,0-2.95.33-3.09.67a14,14,0,0,0,1.44-.23,2.17,2.17,0,0,1-.65.22s0,0,.38,0a2.9,2.9,0,0,1,.61-.05,15.55,15.55,0,0,1-2,.29C478.68,264.15,478.64,264.25,478.74,264.3Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M469.62,268c.16.11.36,0,.53.07v0c-.15.19-.4.24-.57.4A10.71,10.71,0,0,0,473,268a2.72,2.72,0,0,1,.75-.21l0,0-.15.15a3.53,3.53,0,0,0,.64.47c.67,0,.67,0,1.48-.44l0,0c-.06,0-.06,0-.72.07a1.5,1.5,0,0,1,1.27-.26c.14.06.17.06.24,0s.4-.17.44-.44c-.25-.28-.26-.68,0-.82a18.55,18.55,0,0,0,2.07-1.4.91.91,0,0,0-.16-.13.2.2,0,0,1,0-.07h0a12.46,12.46,0,0,1-2.27,1c0-.31.37-.3.52-.47l0-.06a5.73,5.73,0,0,1-.92.09c.12-.1.29-.13.41-.25l0,0c-.43,0-.83.19-1.25.2a9.25,9.25,0,0,1,1.14-.44c-.25-.06-4,.84-4.07,1.24l.1.11c-.09.08-.1.08-.54.17-.74.16-.79.22-.82.31a.22.22,0,0,0,.11.05c.36.05.72-.08,1.08,0s.46.22.72.25a4.24,4.24,0,0,1-1.44.14C469.76,267.22,469.36,267.87,469.62,268Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M482.16,276.83c.1-.11,0-.16-.16-.18a1.39,1.39,0,0,0-.66,0,.51.51,0,0,0-.25.53C481.21,277.42,482,277,482.16,276.83Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M482.24,274.48a.22.22,0,0,0,.14-.05.38.38,0,0,0,0-.37c-.06-.13-.18-.23-.24-.36a4.49,4.49,0,0,0-.25-.73l-.07-.11c-.16-.18-.4-.25-.55-.43s0-.3-.14-.41,0,0-.06,0a7.29,7.29,0,0,0-1.13.68c-.12.08-.27.2-.38.29l-1,.83c.38.16.38.16.34.37s-.05.26,0,.27a1.46,1.46,0,0,0,.46-.15A3,3,0,0,1,481,274C481.46,274.12,481.79,274.48,482.24,274.48Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M480.44,275.78a4.46,4.46,0,0,0-1.29,0c-.21.07-.36.43-.29.53s1.44-.07,1.74-.3C480.69,275.93,480.75,275.83,480.44,275.78Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M457.8,323.58c-.37,0-.37.6-.19.74s.91.56,1,.2S458.26,323.64,457.8,323.58Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M528.89,285.65a.19.19,0,0,0,0-.07,1.15,1.15,0,0,0-.35-.63l-.12-.1c-.32-.22-.74-.27-1-.54s-.32-.5-.63-.59-.75,0-1.12-.05a10.18,10.18,0,0,0-1.08-.19c-.24,0-.18.31-.38.35s-.33-.22-.54-.18l-.11,0c-.17.27,0,.71-.44.85a4.6,4.6,0,0,1-.67-1.24c-.1-.64-1.18-1.4-1.61-1.25,0,.31.35.37.43.62-.24.36-.68.13-1,.35a1.64,1.64,0,0,0,.7.23c.4.06,1.44.88.59,1.2.16.44.64.28.92.48s.26.33.16.63c.06.09.11.14.8.31a4.22,4.22,0,0,1,.74.2c.31.13.55.38.86.51l.13.05a5.33,5.33,0,0,0,1.23.18c.86.09,2.38-.36,2.41-.64s-.08-.34-.08-.52C528.79,285.61,528.79,285.61,528.89,285.65Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M459.38,322.54c.18.58,2.3,1.5,2.43,1.26s-1.59-4.32-1.61-4.35a3.56,3.56,0,0,0-2.6-1.45,4.25,4.25,0,0,0-1.85.39,2.06,2.06,0,0,0,1.47.17c1-.18,1.42.27,1.42.43s-.22.14-.43-.1h0c-.11.4.48.79.87,1.05.72.48.71.66.7,1.22a1.55,1.55,0,0,0,.09.71.82.82,0,0,1,.08.41C459.85,322.56,459.55,322.44,459.38,322.54Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M461.91,326.43c.18.2-.15.56.16.7.54.25.74-.52,1.23-.4a.8.8,0,0,1,.26.12,22.36,22.36,0,0,0,2.26,1c.08,0,.13,0,.16-.05.1-.24,0-.52.12-.76.48-.72-3.45-2.49-3.72-2.54-.07,0-.08,0-.12,0s0,.06,0,.14a1.2,1.2,0,0,1-.06,1.35c-.1,0-.4-.12-.82-.35-.78-.42-.87-.43-.92-.43s0,0,0,.06C460.89,325.76,461.5,326,461.91,326.43Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M486.74,291.41c-.39,0,.27.67.4.81.88.86,1.43.45,1.43.45C488.8,292.43,487.15,291.48,486.74,291.41Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M451.07,277.86l0,0,0,0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M460.83,271m-17.95,15.9c-5.17,6.3-8.71,15.35-8.71,15.35V304c.14.08.14.08.87,6.34l-.62-.2c.08.77,1.34,4.55,1.35,4.58.32-.23.65-.47.12-2.34-.25-.85-.52-1.82-.13-5.88a3.1,3.1,0,0,1,.7,2.6,4.87,4.87,0,0,0,0,1.56c.2.92.55,1.8.79,2.7.32,1.18,1.24,2.1,1.41,3.33.15,1-.45,2,.23,3a2.22,2.22,0,0,0,.38.37,8.8,8.8,0,0,0,.72.65c.85.56,1.75,1.05,2.6,1.6s2.08.37,2.83,1.24c1.72,2,1.72,2,2.44,2.32l.36.17c3.2,1.66,3.13,6.32,6.87,7.48,2.6-2.16,2.46,1.48,2.28,3.15-.06.52-.06.52-1.69,2.23,0,0-2.2,3.36-2.06,4.18,0,.13.05.31.08.44a88.81,88.81,0,0,0,3.85,8.93c.85,1.47,2.41,2.29,3.37,3.66a6.54,6.54,0,0,1,.69,4.59c0,.08-1.11,9.29.57,15.12,2.12,7.39,6.42,8.16,6.46,8.16-3.21-3.39-3.21-3.39-2.26-4.92-.34-.77-.34-.77-.37-3.95.18,0,.18,0,.91.28,0-.08,0-.08-.44-1.63.9-.37.9-.37,1-.87l.19-.06c1.09.82,1.87-.05,1.71-.62l-.18-.63c2.79.9,6.31-5.38,6.35-5.44a3.88,3.88,0,0,1,2.41-.88c1.12-.07,1.54-1.21,2.45-1.6a1,1,0,0,1,.92,0c.39.2.42.21.6-.15.41-.8.63-1.67,1-2.49.18-.47.08-1.05.55-1.4s.75-.55.62-1a.67.67,0,0,1,0-.28,6.06,6.06,0,0,0,4.32-2.27.32.32,0,0,0,0-.09c.05-.3-.11-.58-.06-.87.06-.45.82-.82.39-1.27s-.78-.18-1.12-.39c-1.11-.68-1.54-2-2.57-2.77-1.53-1.14-3.2-2.06-4.79-3.11-.88-.73-.56-1.93-1-2.83-.82-1.06-1.22-2.47-2.11-3.49-1.16-1.34-3.05-1.69-4.19-3.07-.89-1.09-1.25-2.54-2.27-3.56a2.81,2.81,0,0,0-.55-.41c-5.61-3-10-5.31-12.21-.81-1.32-1.86-6.53-1.47-5.09-4.24a5.29,5.29,0,0,0,.57-3.25c-1.13-1.18-2.77-.94-4.12-1.52,1-1.36,1-1.36.9-2.18a8.43,8.43,0,0,0,1.75-2.38c-.18-.32-1.83-3-4.15,2-.77-.33-1.68.61-2.4-.23a6.62,6.62,0,0,1-1.84-4.68c.05-1.12,1.18-1.61,1.49-2.57.2-.61-.51-1.2-.06-1.82a10.62,10.62,0,0,1,3.36-2.08c.88-.29,3.38,1.27,3.39,1.28l.31-.11c-.12-.3-.4-.49-.57-.75l.17-.28a33.83,33.83,0,0,1,5.09,1c1.5,1.63-.53,3.82.88,5.47,2.85-1.47.19-4.6,1.34-6.69s3.66-1.88,5.46-2.89l0,0c0-.08-.08-.19-.12-.28s.1-.18.13-.26l.3,0a3.13,3.13,0,0,1,.15-.32l-.23-.2,1.9-4.05c-.18.63-.85,2.53-.85,2.53.24-.06.24-.06,1.39-2.76a3.66,3.66,0,0,1,.18,1c.61-.52.78-1.41,1.56-1.77a30.38,30.38,0,0,1,3.14-.41c1-2.09,1-2.09,2.61-2.8.2.09.2.09,4.45-.72l-.21.21a2.09,2.09,0,0,0,.59.35l-.1.3c-2.56.74-2.56.74-2.73,1.15,1.37.51,6.5-.47,6.42-2.65-.73.18-1,.9-1.54,1.3l-1-.72a1.08,1.08,0,0,0,.68-.21h0l-.12,0a1.61,1.61,0,0,1-.94-.43.47.47,0,0,1-.11-.62c0-.09,0-.1,0-.11h0a1.08,1.08,0,0,0-.32.79c-.45-.44-.44-.74-.42-1.46-.44-.36-.46-.41-.58-.75.82.06,1.41.11,1.83-.59-.25-.51-.25-.51-6.74.95,5-2.52,5-2.52,9.17-2.34.65.88,5.17.33,6.13-.53,0-.53,0-.54.49-1.12l-.05-.31-.88-.54-.27-.1a4.09,4.09,0,0,0-2,.12l0-.3c.47-.33.63-.33,1.93-.37h0a.41.41,0,0,0,.22-.07c.1-.11-.52-1.19-1.74-1.29-.27,0-.27,0-.39-.11,0-.25.26-.42.18-.69s-.56-.43-.67-.78c0-.15.05-.24.3-.41s.37-.26.16-1.41c-.5-2.89-.5-2.89-1.61-1.86-.17.16,0,.46-.22.59s-.55-.17-.83,0c-.62.43-.62.43-.75.43-.82,0-1.12-.82-1.71-1.18a2.89,2.89,0,0,1,1.17-1.65c-.33-.25-.79-.21-1.12-.48-.08-.06-.11-.14-.16-.38,0-.08-.05-.27-.87-.9a.73.73,0,0,0-.39-.2,21,21,0,0,0-2.72-.52c-.13.84-1.34,1.2-1,2.26-.26.34-.8.29-1,.73s.21,1,.05,1.52c0,0-.68,2.06-1.94,1.92-.28,0-.92-.05-.95.42a1.64,1.64,0,0,1-.42.17c-.72,1.06-.47,2.8-2.13,3.26-.2-.79-.88-1.24-1.31-1.86a2.07,2.07,0,0,0,.6-1.68l.42-.15a1.66,1.66,0,0,0,.06-.21l-.33-.14c-.37-.72-1.2-.47-1.74-.84s-.64-1.1-1.14-1.5a2.11,2.11,0,0,0-.31-.21c-.5-.27-1,0-1.51-.05-.12-.18-.12-.18.11-1.46.07-.44.07-.44-.89-.87.22-1.36,4.17-2.58,5.85-3.11,0-.46-.52-.44-.71-.73,2.76.45,2.76.45,4.8-.6a2.41,2.41,0,0,1-1.95-1c1.09,0,2.13,1,3.26.17a.6.6,0,0,0-.25-.2s.69-.42,1.08.08c1.9,0,1.9,0,2.48-.25a1.74,1.74,0,0,0,.39-.23c.28-.24.1-.67.37-.92s.6-.08.87-.22.24-.27.37-.4-.92-2-2.12-.08c-1.05.2-2.39,2-3.12.7.31-.6,1.73-.56,1.36-1.39-.77,0-1.28.6-1.94.87,0-.38,1-1,1-1.05l-.63-.26c1.64-1.32,1.64-1.32,1.71-1.52l-.11-.17c.92-.72.92-.72,4.28-1.38a1.17,1.17,0,0,0-.52-.14c-2.41-.27-6.9,2.86-6.94,2.89a1.23,1.23,0,0,1,0,.19c.24.08.49.11.74.18,0,.05,0,.11,0,.16a2.78,2.78,0,0,0-1,.22l0,.12h0l.13.08c-.76.65-1.9.57-2.6,1.33-.24-.5-.24-.5.7-1-.35-.24-.35-.24-2,.32-.09,0-.61.15-2.15-.48-.05-.18,0-.37,0-.56-1.38-.12-2,.49-3.29,1.69,0-.42.43-.61.51-1-.72-.13-1.48.23-2.19-.14.41-.2.95-.14,1.24-.57l-.09-.15c-.2,0-.23,0-.69-.18a1.69,1.69,0,0,0-.13-.31,2.56,2.56,0,0,0-1,.26,2.37,2.37,0,0,1,.3-.23,3,3,0,0,0-.64.26,3.28,3.28,0,0,1,1-.7l-1.12.42a92.69,92.69,0,0,0-8.44,5.95A78.11,78.11,0,0,0,442.88,286.85Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M467.16,328.62c-.41.11-.13.68.24.88a3.08,3.08,0,0,0,1.29.26s0-.17-.59-.62S467.32,328.64,467.16,328.62Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M535.16,302.7c.21-.05.41-.12.62-.15s.49.14.73,0,.2-.41.2-.92a2.17,2.17,0,0,0-.1-.62.53.53,0,0,1,.14-.64.79.79,0,0,0,.26-.51,1,1,0,0,0-.21-.63,1.37,1.37,0,0,0-.2-.22c-.17-.18-.39-.31-.56-.48a.64.64,0,0,1-.18-.23s0,0,0,0-1.55-.15-.86.64a.44.44,0,0,0,.19.13.4.4,0,0,1-.15,0,2.61,2.61,0,0,0-1,.26.61.61,0,0,0-.33.45.57.57,0,0,0,.19.43c.14.15.35.18.52.3l-.05,0a6.78,6.78,0,0,0-.85,1.17c-.18.32-.22.49-.15.67S534.36,302.89,535.16,302.7Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M542.75,323.25a.19.19,0,0,0,.16,0,2.71,2.71,0,0,0,.37-.21c.06-.09-.09-.24-.39-.39s-.91-.27-.78.05A1.44,1.44,0,0,0,542.75,323.25Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M538.38,301.64c-.07,0-.07,0-.07.09l.4.17A1.14,1.14,0,0,0,538.38,301.64Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M553.8,311.19a8.34,8.34,0,0,1,1.5,2.85c-.34-1.6-.75-3.74-1.16-5.33-1.91-6.29-1.94-6.42-3.36-9.66l-1.57-3.32h0c-.06-.11-.12-.23-.19-.34.06.18.08.24.72,1.65-.15-.17-.25-.37-.38-.55a6.09,6.09,0,0,0,.77,1.63l-.12,0c-1.21-2-2.06-4.15-3.3-6.11a25.11,25.11,0,0,0,1.85,2.61,26.18,26.18,0,0,0-3.24-5.28,9.26,9.26,0,0,1-1.15-1.51l.2.17a5.18,5.18,0,0,0-.42-.57l-.12,0a6.35,6.35,0,0,1-.9-1.08,1.84,1.84,0,0,0,.22.17c0-.38-1.29-1.59-1.39-1.66a1.31,1.31,0,0,0,.16.57c-.46-.36-.53-1-1-1.37,0,.27.24.47.25.74-.33.35-.33.35-.39.61a21.62,21.62,0,0,0,.39,3c.41,1.71.21,2.18.18,2.23-.63,1.22-.63,1.22-1.51,1.48-.33.1-.36.19-.34.58,0,0,.34,5.15,2.38,4.95.65-.06.7-1.09.72-1.58a41.84,41.84,0,0,1,2.38,5.55c.12.57.22,1.1.7,1.27a3.74,3.74,0,0,0,.54-2c-.25-1.54,0-1.63.43-1.83.12-.31.13-.44-.57-1.36-.48-.63-.48-.63-.85-2.31-.14-.64.63-1.11.32-1.78a13.35,13.35,0,0,1-.8-1.84s0-.13,0-.18l.1-.08a7.23,7.23,0,0,1,1.61,2.26l-.13,0c.26,3.13.26,3.13,1,4.59.67,1.28,2.24,1.68,2.92,3a2.3,2.3,0,0,1-.41-.35l-.12,0c0,.14.06.27.09.41a12.35,12.35,0,0,0-1.57-1.11,22.17,22.17,0,0,1,1.21,3.37c-.65-.26-.36-1.22-1.08-1.41l-.11.08s.28,1.74.33,1.87.35,1,.2,1.34c-.38-.18-.38-.18-.47-.19s-.16.24-.26.34l0,.12h0c-1.8-.78-1.8-.78-1.88-.6l-.31.06a4.92,4.92,0,0,0-1.21-.94l.83.47a1.92,1.92,0,0,0-1.13-.83c-.25-.07-.31-.09-.72-1.12a3.78,3.78,0,0,1-.31-2.51c.11-.29.1-1.71-.22-1.86,0,0-1-.36-1,.17a22.81,22.81,0,0,0,1,4.11,2.3,2.3,0,0,1,.21.62c-.06,0-.08,0-.36,0l-.64-.12a15,15,0,0,1-1.59-2.05,6.24,6.24,0,0,0-.57-1.23,3.22,3.22,0,0,0-1.35-1h0c.49-.2,1.56-1.68.57-2.08a3.61,3.61,0,0,0-.54-.14c-.67-.14-.79-.17-.74-.34.11-.33.9-.76.44-.95,0,0-1.26-.42-1.6,0,0,0,0,.1,0,.15-.08.42.08.83,0,1.24s-.42.56-.41.93c.09.08.31.13.87-.05.2-.07.38-.13.46,0,.37.41-.33.72-.3,1.13a1.52,1.52,0,0,0,.82,1.34c.67.45.75.51.86.65s-.13.22-.11.35c.08.42.34.78.39,1.21s-.43,0-.71-.25c-.12-.12-.12-.12-.52-.29,0,.53.45,1,.38,1.51,0,.3-.35.35-.79.4-.11,0-.29,0-.27.17s.1.31,1,.6c.38.12,1.16.37,1.11.63a2,2,0,0,0-.68-.06v.1a.5.5,0,0,0-.33.05c-.26.11-.38.37-.61.5s-.63.2-.92.35a.19.19,0,0,1,0,.08c.09.06.11.07,1,.26a1.67,1.67,0,0,1-.27.39c-.92-.38-1-.54-1.34-1,0,.22.11.5.17.71l-.2.28a5.93,5.93,0,0,1-.73,0c-.35-.45-.35-.45-1.08-.73l-.23.24c.13.23.3.53.42.76l-.31.09a5.33,5.33,0,0,1,1.69,7c-2-.87-3.76-2.18-5.73-3.1a3.13,3.13,0,0,0,.2.68c0,.06-1.72,5.61-1.08,6.06-.79,1.62-.79,1.62-.88,1.76a7.09,7.09,0,0,1,2.34.83,7.51,7.51,0,0,0-.1,1.07l3.73.06c1,.21,1.61-.88,1.38-1.84,1.31-2,1.34-2,2.9-2.07.65-1.76.65-1.76.84-1.83.82-.31,1,.71,1.62.92.88-.77,1.55-1.24,2.14-.21a74.67,74.67,0,0,1,2.52,7.32,1.32,1.32,0,0,0-.14.74c.06.15.31.18.28.4s-.16.37-.18.57a.26.26,0,0,0,.13.26l.07,0c-.14.61-.57.53-2.22.19a10.27,10.27,0,0,0,1,2.25c.36-.47.2-1.1.49-1.6l.28.14c.38-.28.63-.68,1-1v-.05a.67.67,0,0,0,.42-.39,1.05,1.05,0,0,0,.05-.19c0-.23,0-.46.08-.68,0,0,0,0,0-.05.06.19.12.41.18.58a1.65,1.65,0,0,0-.09-.89c0-.11.07-.23.09-.34.07-.38,0-.47-.16-.53a.85.85,0,0,0-.25,0c-.11-.31-.25-.7-.43-1.18l.16-.24a.59.59,0,0,0,0,.13s.3.76.32.78.34-.93.4-1.41a4.73,4.73,0,0,0,0-.71l.77,2s0,0,0,4.33l.27,3.76A4.85,4.85,0,0,0,549,330a12.75,12.75,0,0,0,.34-2.39c.36-2.59.36-2.59.66-2.68a2.44,2.44,0,0,1,1.06,1.87,4.16,4.16,0,0,0,.46-.48l.32.09c1.07-2.1.17-4.55,1.21-6.65a.9.9,0,0,1,.56.23c-.06.06-.15.16-.22.22a2.41,2.41,0,0,0,.5.86,1.69,1.69,0,0,1-.36,1,12.12,12.12,0,0,1,.29,1.33c1.28-.24.07-1.88.7-2.67.51.07.54.25.55.67-.08.06-.18.16-.26.23a3.47,3.47,0,0,1,0,1.35l-.26.19c.1,2.16,1.31,4.23.46,6.45l-.32.06c-.7-.94.06-2.95-1.56-3.08a1,1,0,0,1-.42.46,6.3,6.3,0,0,0-.53-.37,1.15,1.15,0,0,0,.11.6c-.45.17-.84-.17-1.28-.12a3.91,3.91,0,0,0-.27.67l.25.18c-.25,1.18-.71,3.37.27,5l.29-.14.1-.31c.31.54.24,1.23.65,1.73a2.75,2.75,0,0,0,.35-.56,1.78,1.78,0,0,0,.39.51c-1.27,4.34-1.46,5-2.34,6-.59-.27-.64-.43-.63-1.1a.88.88,0,0,0-.6,0c-2-.86-.75-3.76-2.87-4.54-.64.57-.62,1.5-1.15,2.13h-.33a79.08,79.08,0,0,1-3.64-7c0-.21.2-.47.37-.61.4-.31.4-.31,1.09-2.9a8.85,8.85,0,0,0-.73-.87c-.52.17-.52.17-2.09-.83a2.85,2.85,0,0,0-.6.37c-1.91-1.65-4.56.15-6.5-1.38l-.32-.14c-.67-.1-.9-.13-1.29-1.18-.09-.13-.1-.13-.1-.13a3.88,3.88,0,0,0-.36.15c-.6.37-.54,1.2-1.12,1.56-.73.46-1.67.12-2.38.64-.22.16-.28.55-.38.79-1.08,2.63-1.08,2.63-1.92,2.73a8.3,8.3,0,0,0-2.39.73c-.63.5-5.4,4.6-5.4,4.6-.6,1.33-.1,2.81-.55,4.15-.37,1.14-2.17,1.11-2.11,2.59.07,2.22.49,4.4.73,6.6.1.93,2,4.64,2.55,4.78,2.76.69,5.7.59,8.34,1.85a.67.67,0,0,1,.21.23c.35.59-.27,1.21.07,1.8s1,.59,1.49.94a2.1,2.1,0,0,1-.82,2.06c-2.22,2.43-2.22,2.43-2.32,3.31-.16,1.39-.38,3.3-3.38,6.59-1.39,1.51-3.3,2.31-4.86,3.57s-2.21,3-3.6,4.19c-5.44,4.79-5.58,4.85-6.31,5.21a4.16,4.16,0,0,0-1.45,1.12c1.53,1.13,4,.46,4.85.25l3.31-.94,4.3-1.5c1-.53,1.85-1.4,2.93-1.86s2.61-.52,3.84-1.07a27.84,27.84,0,0,0,6.8-5.21c1.58-1.77,5.59-3.92,6.77-4.53a26.81,26.81,0,0,0,6.06-5.7c-.3-.24-.3-.24-1-.32-.07-.23-.07-.23,1.08-2.6a21.44,21.44,0,0,0,.83-2.76c.78-2.37,2.06-4.55,2.68-7l2-7.65c.07.28.07.28-.16,1.41a1.25,1.25,0,0,0,.55-.47c-.45,6.14-4,11.19-5.83,16.87.72-.07.72-.07,1,.08,2.86-2.93,2.86-2.93,3.1-3.36l-.17.32.33-.58.1-.2.63-1.23c.28-.57.64-1.28,1.48-3.24,0,.1-.07.2-.11.29.69-1.71,1.57-3.85,2.15-5.53s1.22-4,1.64-5.8c.1-.53.2-1,.29-1.49.06-1.49.1-1.71,1-6.76,0,0,0,.05,0,.07.32-7.17.32-7.17.4-7.5l0,0a40.17,40.17,0,0,0-.28-5.43L555.3,314A8.84,8.84,0,0,0,553.8,311.19Zm-12.06-7.95s0,0,.28.15l-.31-.11h0Zm5.89,17.17,0,0a5.12,5.12,0,0,0-.19.67.51.51,0,0,1-.32.34.18.18,0,0,0-.15.17,0,0,0,0,0,0,0c-.61-.59-1.1-1.1-1.65-5.78a1.11,1.11,0,0,1,.58-.21l1.81,4.69A.11.11,0,0,0,547.63,320.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M555.79,322.77c1.18,34.83-24.17,63.47-59,65.69,65-30.44,59.4-97.51-4.59-126.34C524.26,260.33,554.61,288,555.79,322.77Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M482.33,386.57s3.35-25.87,3.12-30.33,1.56-18.39-2.23-29.88c-1.79-5.42-6.47-16.53-6.69-16.72,0,0,6,10.59,8,17.06s2.45,16.94,2.57,22.74-2,35.34-1,39.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,338.21c3.48-2.64,5.06-7.13,5.52-11.47a18.29,18.29,0,0,0-1.14-9.25c-1.63-3.66-4.85-6.35-8.11-8.69A93.8,93.8,0,0,0,470,301c-1.32,5.13-.59,10.56.46,15.76,1,4.76,2.21,9.55,4.8,13.66s6.72,7.47,11.54,8.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.28,329.94c-.38.06,4.14,18.48,13.49,23.9S484.23,356,484.23,356s.74-14-6.8-19.33S457.46,329.41,454.28,329.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.28,331.06c.05-.34-16.85-1.32-23.93,5.23s-6.14,13.48-6.14,13.48,11.77,4.32,18.28-.72S518.9,333.92,519.28,331.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.88,379.09c-7-9-20.52-12.27-30.86-7.39a21,21,0,0,0-23.09-3.4,20.94,20.94,0,0,0-33,1.54,20.27,20.27,0,0,0-21.48,5.25l23.28,9.75h75Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.82,373s18.7,20.86,50.15,20.88,58.51,0,58.51,0,30-1.77,43.78-19.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.88,337.19c0,.08-1.39.67-3.62,1.75a76.26,76.26,0,0,0-16.2,10.45C488.17,351,487,352,487,352a4.35,4.35,0,0,1,.71-.82c.48-.5,1.21-1.2,2.13-2a62.18,62.18,0,0,1,7.73-5.89,63,63,0,0,1,8.56-4.62c1.14-.5,2.07-.87,2.73-1.1A4.45,4.45,0,0,1,509.88,337.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.77,314a3.5,3.5,0,0,1,.52.82c.31.55.73,1.36,1.2,2.38a59.58,59.58,0,0,1,5,16.79c.16,1.11.25,2,.29,2.64a3.36,3.36,0,0,1,0,1,35.74,35.74,0,0,1-.66-3.57,81.56,81.56,0,0,0-2-8.49,79.73,79.73,0,0,0-2.94-8.2C479.29,315.33,478.7,314.07,478.77,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.15,336.5a5,5,0,0,1,.92.8c.56.55,1.39,1.31,2.44,2.23,2.09,1.85,5.13,4.22,8.47,6.88,1.67,1.35,3.22,2.67,4.58,3.93A43.51,43.51,0,0,1,483,353.9c.47.52.84,1,1.18,1.49a9.51,9.51,0,0,1,.82,1.17,5.4,5.4,0,0,1,.62,1.05c-.08.05-1-1.4-2.9-3.47-.92-1-2.11-2.2-3.46-3.44s-2.92-2.54-4.58-3.88c-3.34-2.66-6.36-5.08-8.4-7-1-1-1.82-1.76-2.34-2.36A6.05,6.05,0,0,1,463.15,336.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.15,
    y: 135.26,
    width: 291.71,
    height: 7.33,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.33,464.45v-7.34s20.21-2.45,27.3-21.15c.46,1.07,31.51-14.12,32.9-33.82h11.83v62.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.19,464.45v-7.34S427,454.66,419.88,436c-.45,1.07-31.51-14.12-32.89-33.82H375.16v62.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M388.78,405.84,364,408.6a6.05,6.05,0,0,0,2.15,5.07,12.3,12.3,0,0,0,5,2.42c3.85,1,8.07,1.24,11.68-.47S389.24,409.93,388.78,405.84Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.89,
    cy: 397.42,
    rx: 15.93,
    ry: 16.49,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.89 391.04 351.28 358.03 369.43 332.41 363.58 323.11 369.61 151.39 375.89 151.39 375.89 391.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.89 391.04 400.5 358.03 382.35 332.41 388.2 323.11 382.17 151.39 375.89 151.39 375.89 391.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.86,139.92a13,13,0,1,1-13-13.43A13.2,13.2,0,0,1,388.86,139.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.86,139.92a24.69,24.69,0,0,0-.49-3.2,13.39,13.39,0,0,0-4.66-7.27,12.69,12.69,0,0,0-5.42-2.5,12.43,12.43,0,0,0-6.8.6,12.18,12.18,0,0,0-3.24,1.84,12.33,12.33,0,0,0-2.66,2.82,13.21,13.21,0,0,0-1.78,3.61,13.42,13.42,0,0,0,0,8.19,13.07,13.07,0,0,0,1.78,3.61,12.33,12.33,0,0,0,2.66,2.82,11.65,11.65,0,0,0,3.24,1.84,12.44,12.44,0,0,0,6.8.61,12.58,12.58,0,0,0,5.42-2.51,13.41,13.41,0,0,0,4.66-7.26,25.24,25.24,0,0,0,.49-3.2,4.9,4.9,0,0,1,0,.84,6.9,6.9,0,0,1-.07,1,10.69,10.69,0,0,1-.23,1.38,13.52,13.52,0,0,1-4.63,7.49,13,13,0,0,1-5.57,2.65,12.86,12.86,0,0,1-7.05-.59,12.25,12.25,0,0,1-3.37-1.89,12.84,12.84,0,0,1-2.77-2.92,13.46,13.46,0,0,1-1.85-3.74,14,14,0,0,1,0-8.5,13.46,13.46,0,0,1,1.85-3.74A12.84,12.84,0,0,1,368,129a12.25,12.25,0,0,1,3.37-1.89,12.86,12.86,0,0,1,7.05-.59,13.37,13.37,0,0,1,10.2,10.14,12.76,12.76,0,0,1,.23,1.38,6.78,6.78,0,0,1,.07,1A5,5,0,0,1,388.86,139.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "363.58 323.11 388.2 323.11 382.35 332.41 369.43 332.41 363.58 323.11"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M387.56,323.14s.2-.05.64-.08v.16c-1.54.1-6.26.17-11.83.17-3.44,0-6.55,0-8.81-.07-1.12,0-2-.05-2.67-.08a3.29,3.29,0,0,1-1-.1,3.29,3.29,0,0,1,1-.1c.63,0,1.55-.06,2.67-.08,2.26,0,5.37-.07,8.81-.07,5.57,0,10.29.07,11.83.17v.16C387.76,323.19,387.56,323.17,387.56,323.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,332.21s.11,0,.34-.07v.15c-.83.1-3.37.18-6.36.18a43.94,43.94,0,0,1-6.7-.26A44.8,44.8,0,0,1,376,332c3,0,5.53.07,6.36.17v.16C382.13,332.26,382,332.24,382,332.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M351.28,358l18.15,24.31a19.82,19.82,0,0,1,12.95,0L400.5,358Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M400.5,358.1c0,.14-11,.26-24.58.26s-24.6-.12-24.6-.26,11-.25,24.6-.25S400.5,358,400.5,358.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.72,382.36a28.54,28.54,0,0,0-6.72-.83c-3.75.1-6.71,1-6.75.83a6.52,6.52,0,0,1,1.9-.66A21.59,21.59,0,0,1,376,381a16.51,16.51,0,0,1,4.86.58A5.54,5.54,0,0,1,382.72,382.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.22,404.87a4.73,4.73,0,0,1-.52,1.18,15.44,15.44,0,0,1-2,2.87,16.6,16.6,0,0,1-4,3.3,16,16,0,0,1-6.06,2,15.65,15.65,0,0,1-6.38-.61,16.21,16.21,0,0,1-4.68-2.31,15,15,0,0,1-2.61-2.36,5.48,5.48,0,0,1-.77-1,25.24,25.24,0,0,0,3.58,3.09,16.3,16.3,0,0,0,10.8,2.72,16.6,16.6,0,0,0,9.9-5.1A24.92,24.92,0,0,0,390.22,404.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,435.82c0,.14-19.5.26-43.55.26s-43.55-.12-43.55-.26,19.5-.25,43.55-.25S419.88,435.68,419.88,435.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.82,457.13c0,.14-31.76.25-70.93.25s-70.93-.11-70.93-.25,31.75-.26,70.93-.26S446.82,457,446.82,457.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.63,
    cy: 136.66,
    r: 9.39,
    transform: "translate(80.05 369.72) rotate(-79.41)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.84,134.81c-.07,0-.19-.82-.84-2.15a9.37,9.37,0,0,0-4.35-4.27,9.16,9.16,0,0,0-8.77.46,8.69,8.69,0,0,0-2,1.68,8.89,8.89,0,0,0-1.5,2.29,9.07,9.07,0,0,0,2.13,10.58,8.72,8.72,0,0,0,2.27,1.53,8.87,8.87,0,0,0,2.51.77,9.27,9.27,0,0,0,10.63-8.59c.08-1.48-.13-2.3-.06-2.3a7.3,7.3,0,0,1,.26,2.31,9.51,9.51,0,0,1-5.87,8.44,9.54,9.54,0,0,1-5,.61,9.26,9.26,0,0,1-2.65-.79,9,9,0,0,1-2.4-1.6,9.55,9.55,0,0,1-2.26-11.17,9.28,9.28,0,0,1,1.6-2.41,9.38,9.38,0,0,1,2.14-1.76,9.51,9.51,0,0,1,9.18-.38,9.42,9.42,0,0,1,4.38,4.51A7.42,7.42,0,0,1,271.84,134.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.14,
    cy: 141.76,
    r: 9.39,
    transform: "translate(99.55 472.15) rotate(-55.64)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.35,139.9c-.07,0-.19-.81-.84-2.14a9.28,9.28,0,0,0-4.35-4.27,9.14,9.14,0,0,0-4.14-.9,9.27,9.27,0,0,0-4.63,1.36,9.06,9.06,0,0,0-3.52,4A9.11,9.11,0,0,0,491,148.5a8.44,8.44,0,0,0,2.27,1.52,8.25,8.25,0,0,0,2.52.77,9.1,9.1,0,0,0,4.79-.54,9.27,9.27,0,0,0,3.47-2.42,9.45,9.45,0,0,0,2.36-5.63c.08-1.47-.13-2.29-.06-2.3a7.37,7.37,0,0,1,.26,2.31,9.32,9.32,0,0,1-2.29,5.86,9.42,9.42,0,0,1-3.58,2.58,9.54,9.54,0,0,1-5,.62,9.71,9.71,0,0,1-5-2.39,9.56,9.56,0,0,1-2.26-11.18,9.23,9.23,0,0,1,1.6-2.4,9.38,9.38,0,0,1,2.14-1.76,9.55,9.55,0,0,1,9.18-.39,9.35,9.35,0,0,1,4.38,4.52A7.41,7.41,0,0,1,506.35,139.9Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Reputation--inject-19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 647.02,
    cy: 221.63,
    r: 37.89,
    transform: "translate(-19.53 374.82) rotate(-31.85)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.3,214.3s9.24-7,11.3-9.41a17.84,17.84,0,0,0,3.54-6.36c1.67-4.71.42-11.31,1.09-14.06.79-3.25,5.78-2.4,7.81,2.1a20.56,20.56,0,0,1,2.1,11.71,83.32,83.32,0,0,1-1.38,9.58s21.3,1.3,24,3.65c5.34,4.6.16,10.18.16,10.18a7.87,7.87,0,0,1,2.08,4.79c.09,2.77-2.3,5.93-2.3,5.93a7.22,7.22,0,0,1,.47,6c-1.31,3-2.32,3.33-2.32,3.33s0,5.06-2.56,7.31-15.12,2.23-18.34,2.15-15.2-1-22.65-3.94-13-2.17-13-2.17l.79-32Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.94,221.69a2,2,0,0,1-.52.12c-.34.06-.84.13-1.49.21-1.29.17-3.17.38-5.5.54s-5.12.25-8.21.15a28,28,0,0,1-4.86-.45,5.56,5.56,0,0,1-2.39-1.14,4,4,0,0,1-1.36-2.4,5.67,5.67,0,0,1,1.73-4.95,8.08,8.08,0,0,1,4.61-1.68,80.35,80.35,0,0,1,8.18-.68c2.33-.09,4.22-.11,5.52-.14l1.5,0a2.15,2.15,0,0,1,.53,0,1.71,1.71,0,0,1-.52.08c-.34,0-.85.08-1.5.12l-5.51.3c-2.33.13-5.09.36-8.14.79a7.8,7.8,0,0,0-4.33,1.59,5.18,5.18,0,0,0-1.55,4.48,3.48,3.48,0,0,0,1.17,2.1,5.37,5.37,0,0,0,2.18,1,29,29,0,0,0,4.76.46c3.07.13,5.84.07,8.17,0s4.2-.26,5.5-.37l1.5-.12A3.09,3.09,0,0,1,674.94,221.69Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.4,231.7a2.59,2.59,0,0,1-.49.1l-1.42.19c-1.23.14-3,.32-5.23.45s-4.86.23-7.8.16c-1.47,0-3-.08-4.61-.26a8.94,8.94,0,0,1-2.42-.6,4.08,4.08,0,0,1-2-1.71,3.85,3.85,0,0,1-.36-2.61,5,5,0,0,1,1.14-2.27,8.45,8.45,0,0,1,4-2.33,16.86,16.86,0,0,1,4.17-.48c1.31,0,2.52-.05,3.63-.05,2.22,0,4,0,5.24,0a15.75,15.75,0,0,1,1.93,0,1.68,1.68,0,0,1-.49.09c-.33,0-.81.09-1.43.14-1.23.1-3,.17-5.24.21-1.11,0-2.32.06-3.62.12a17.1,17.1,0,0,0-4.06.51,8.18,8.18,0,0,0-3.8,2.21,3.85,3.85,0,0,0-.7,4.28,3.48,3.48,0,0,0,1.74,1.49,8.88,8.88,0,0,0,2.28.58c1.55.18,3.1.22,4.56.28,2.92.09,5.55,0,7.76-.05s4-.21,5.23-.29A13.92,13.92,0,0,1,674.4,231.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.12,241.26a2.05,2.05,0,0,1-.43.1q-.42.09-1.23.21c-1.08.15-2.64.35-4.57.49a61.28,61.28,0,0,1-6.83.14,17.66,17.66,0,0,1-4-.46,4.24,4.24,0,0,1-1.91-1.17,3.72,3.72,0,0,1-.91-2.13,5.32,5.32,0,0,1,1.45-4.16,7.09,7.09,0,0,1,3.53-2.09,6.37,6.37,0,0,1,1.93-.13l1.76.05,3.17.06c1.93,0,3.5,0,4.58-.08a13.32,13.32,0,0,1,1.68,0,1.24,1.24,0,0,1-.43.09c-.28.05-.7.1-1.24.15-1.08.11-2.65.22-4.59.25-1,0-2,0-3.18,0l-1.77,0a6.11,6.11,0,0,0-5.07,2.12,4.86,4.86,0,0,0-1.3,3.76,3.22,3.22,0,0,0,.77,1.83,3.66,3.66,0,0,0,1.68,1,18.17,18.17,0,0,0,3.92.47c2.55.12,4.85.07,6.78,0s3.5-.23,4.58-.32A10.44,10.44,0,0,1,673.12,241.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.22,242.25c0,.09-.78.25-1.91.83a7.83,7.83,0,0,0-3.4,3.41,3.38,3.38,0,0,0-.26,2.52,2.91,2.91,0,0,0,1.32,1.6,4.7,4.7,0,0,0,1.95.43s-.18.12-.55.17a2.92,2.92,0,0,1-1.57-.28,3.11,3.11,0,0,1-1.6-1.76,3.76,3.76,0,0,1,.23-2.89,7.49,7.49,0,0,1,3.72-3.53A4.35,4.35,0,0,1,659.22,242.25Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633,231.28c0-.1,1.7-.47,4.21-1.74a22.25,22.25,0,0,0,12.13-17.16c.36-2.79.13-4.55.24-4.55a5.18,5.18,0,0,1,.18,1.22,19.51,19.51,0,0,1,0,3.37,21.54,21.54,0,0,1-12.34,17.45A19.11,19.11,0,0,1,634.2,231,5,5,0,0,1,633,231.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.27,
    y: 209.31,
    width: 12.23,
    height: 40.23,
    transform: "translate(5.92 -15.35) rotate(1.43)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.72,193a3.31,3.31,0,0,1-.08-.89,8.06,8.06,0,0,0-.09-1.08,12.3,12.3,0,0,0-.25-1.45,13.77,13.77,0,0,0-1.4-3.74,14,14,0,0,0-3.35-4.06,13.76,13.76,0,0,0-12.9-2.55,12.74,12.74,0,0,0-3.55,1.7,15.7,15.7,0,0,0-1.61,1.24,17,17,0,0,0-1.42,1.52,13.65,13.65,0,0,0-.8,16.15,17.24,17.24,0,0,0,1.26,1.66,15,15,0,0,0,1.49,1.39,13,13,0,0,0,3.36,2,13.81,13.81,0,0,0,7.17,1,13.64,13.64,0,0,0,5.92-2.24,14,14,0,0,0,3.73-3.71,13.77,13.77,0,0,0,1.77-3.59,10.15,10.15,0,0,0,.38-1.42,6.83,6.83,0,0,0,.2-1.06,3.55,3.55,0,0,1,.17-.89,4.85,4.85,0,0,1,0,.91,6.13,6.13,0,0,1-.13,1.08,9.87,9.87,0,0,1-.33,1.46,13.06,13.06,0,0,1-1.69,3.75,14.24,14.24,0,0,1-17.45,5.39,13.37,13.37,0,0,1-3.56-2.12A15.53,15.53,0,0,1,660,202a16.4,16.4,0,0,1-1.34-1.74,14.34,14.34,0,0,1,.84-17,16.3,16.3,0,0,1,1.5-1.6,15.11,15.11,0,0,1,1.71-1.3,13.38,13.38,0,0,1,3.75-1.77,14.31,14.31,0,0,1,7.58-.21,14.21,14.21,0,0,1,9.26,7.3,13,13,0,0,1,1.31,3.89,8.72,8.72,0,0,1,.18,1.48,5.93,5.93,0,0,1,0,1.1A4.24,4.24,0,0,1,684.72,193Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.13,184.13c0,.05-.23.26-.73.61l-.92.63-.59.38-.7.34a15.86,15.86,0,0,1-8.31,1.88l-1.25-.09-1.2-.22-.58-.11-.55-.16c-.37-.11-.73-.21-1.08-.33a18,18,0,0,1-3.46-1.7,8.2,8.2,0,0,1-2.68-2.31c.08-.09,1.08.81,3,1.84a21.77,21.77,0,0,0,3.41,1.5l1,.28.53.15.56.1,1.14.2,1.19.08a17.17,17.17,0,0,0,8.05-1.6l.71-.29c.21-.1.41-.22.6-.32l1-.5C681.78,184.22,682.1,184.09,682.13,184.13Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.22,200.66s.23-.26.72-.61l.92-.63.59-.38.7-.34a15.88,15.88,0,0,1,8.31-1.87l1.25.08,1.2.22.58.11.56.17c.36.11.73.2,1.07.32a18.27,18.27,0,0,1,3.46,1.71,7.94,7.94,0,0,1,2.68,2.31c-.08.08-1.08-.81-3-1.84a21,21,0,0,0-3.42-1.5c-.33-.11-.68-.19-1-.29l-.53-.15-.56-.1-1.14-.19-1.19-.08a17.07,17.07,0,0,0-8,1.6l-.7.28-.61.32-1,.51C659.56,200.57,659.25,200.7,659.22,200.66Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.7,193.31c0,.21-6.3.08-14.06-.31s-14-.86-14-1.07,6.3-.08,14.06.3S684.71,193.1,684.7,193.31Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.67,206.31c-.21,0-.08-6.3.31-14.05s.86-14,1.07-14,.08,6.3-.3,14.06S669.88,206.32,669.67,206.31Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.67,206.29c0,.08-1.58-1-3.3-3.43a18.59,18.59,0,0,1-2.4-4.62,16.86,16.86,0,0,1-.93-6.32,16.22,16.22,0,0,1,1.57-6.2,19.51,19.51,0,0,1,2.86-4.35c1.95-2.24,3.53-3.22,3.58-3.13s-1.36,1.2-3.16,3.47a21.16,21.16,0,0,0-2.63,4.31,16.06,16.06,0,0,0-1.45,5.93,17.08,17.08,0,0,0,.83,6.06,21,21,0,0,0,2.18,4.55C668.39,205,669.75,206.21,669.67,206.29Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.37,178.25c0-.08,1.58,1,3.3,3.43a18.59,18.59,0,0,1,2.4,4.62,17.09,17.09,0,0,1,.93,6.33,16.22,16.22,0,0,1-1.57,6.19,19.36,19.36,0,0,1-2.86,4.36,12,12,0,0,1-3.58,3.13c-.08-.09,1.36-1.21,3.16-3.48a21.07,21.07,0,0,0,2.63-4.3,16.17,16.17,0,0,0,1.45-5.94,17.08,17.08,0,0,0-.83-6.06,20.67,20.67,0,0,0-2.18-4.54C672.65,179.55,671.29,178.33,671.37,178.25Z",
    style: {
      fill: "#FF822F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Behavior--inject-19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 579.15,
    cy: 114.69,
    r: 34.02,
    transform: "translate(88.53 443.11) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.72,145.1a6.2,6.2,0,0,0,1.73-2,3.41,3.41,0,0,1,.54-.71l7.69,10.35a1.7,1.7,0,0,0,2.4.36l10.78-8-.91-1.22a2.74,2.74,0,0,0-.77-.71,5.69,5.69,0,0,1-.23-9.57,5.75,5.75,0,0,1,7.54,1,5.57,5.57,0,0,1,1.25,2.57,2.79,2.79,0,0,0,.49,1.13l.64.85,11-8.07a2.11,2.11,0,0,0,.43-3l-7.12-9.62.74-.55.27-.18a6.95,6.95,0,1,0-4.21-12.53,7,7,0,0,0-2.22,2.79,2.16,2.16,0,0,1-.41.39l-1,.71-8-10.72a2.1,2.1,0,0,0-3-.44L568.6,120.16a1.73,1.73,0,0,0-.36,2.41l8.11,10.91a4.11,4.11,0,0,1-.68.21,6.26,6.26,0,0,0-3.42,1.86,6.41,6.41,0,0,0,8.47,9.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.73,98.29a6.23,6.23,0,0,0-2.55.58,3.24,3.24,0,0,1-.85.27l-.2-12.9a1.74,1.74,0,0,0-1.75-1.7L571,84.75l0,1.52a2.8,2.8,0,0,0,.22,1,5.9,5.9,0,0,1,.45,2.11,5.71,5.71,0,1,1-10.91-2.23A2.8,2.8,0,0,0,561,86V84.9l-13.6.17a2.11,2.11,0,0,0-2.08,2.15l.17,12h-.93c-.1,0-.21,0-.32,0a6.87,6.87,0,0,0-4.11-1.27,6.95,6.95,0,1,0,3.65,12.92,3.43,3.43,0,0,1,.56-.07l1.19,0,.21,13.36a2.12,2.12,0,0,0,2.14,2.08l37.15-.58a1.72,1.72,0,0,0,1.69-1.74l-.21-13.6a3.32,3.32,0,0,1,.67.23A6.27,6.27,0,0,0,591,111a6.41,6.41,0,0,0-1.3-12.7Z",
    style: {
      fill: "#FF822F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Reliability--inject-19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 372.46,
    cy: 74.2,
    r: 36.8,
    transform: "translate(56.62 285.1) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.92,104h-.12a4.49,4.49,0,0,1-4.36-4.59l.05-2.06a1,1,0,0,1,1-1,1,1,0,0,1,1,1l-.06,2a2.49,2.49,0,0,0,.69,1.78,2.46,2.46,0,0,0,1.73.77,2.53,2.53,0,0,0,1.77-.69,2.42,2.42,0,0,0,.77-1.73l1.43-57.2a1,1,0,0,1,2,.05l-1.43,57.2A4.49,4.49,0,0,1,369.92,104Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.25,75.9c-3.82-3.42-8.92-4.6-16.22-1.88,0,0,8.3-26.17,35.66-26.23l-.77,30.79S367.57,69.64,355.25,75.9Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.69,76.84c4-3.23,9.15-4.15,16.3-1.08,0,0-7-26.54-34.3-28l-.77,30.79S380.7,70,392.69,76.84Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,48a38.86,38.86,0,0,0-4.45,2.56,29.47,29.47,0,0,0-8.22,9.14,50.88,50.88,0,0,0-4.72,11.45c-.44,1.54-.77,2.78-1,3.65a7.24,7.24,0,0,1-.4,1.33,6,6,0,0,1,.2-1.38c.17-.88.44-2.14.84-3.69a45.47,45.47,0,0,1,4.63-11.62,28,28,0,0,1,8.45-9.18A19.65,19.65,0,0,1,373,48.48,5.84,5.84,0,0,1,374.27,48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.58,76a8.44,8.44,0,0,1,.07,1.58h-.23c0-2.33,0-7.25.18-12.93.1-4,.22-7.64.33-10.26.07-1.23.12-2.27.16-3.11a5.28,5.28,0,0,1,.13-1.14,4.75,4.75,0,0,1,.08,1.14v3.11c0,2.63-.08,6.26-.18,10.27-.14,5.68-.32,10.6-.47,12.93h-.23A6.62,6.62,0,0,1,373.58,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,48.1a5.62,5.62,0,0,1,1.27.54,20.13,20.13,0,0,1,3.16,2,28.88,28.88,0,0,1,7.68,9.7,56.49,56.49,0,0,1,4.15,11.68c.38,1.54.66,2.79.84,3.65a5.94,5.94,0,0,1,.23,1.36,7.76,7.76,0,0,1-.42-1.31c-.27-1-.6-2.16-1-3.61a64.83,64.83,0,0,0-4.25-11.54A30.42,30.42,0,0,0,379.65,51,36,36,0,0,0,375.45,48.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.36,
    cy: 55.99,
    r: 10.64,
    transform: "translate(73.06 293.26) rotate(-43.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,56.25a23.94,23.94,0,0,0-.37-2.58,10.52,10.52,0,0,0-3.74-5.83,10.39,10.39,0,0,0-4.35-2,10.54,10.54,0,0,0-5.48.33,9.85,9.85,0,0,0-2.66,1.36,9.75,9.75,0,0,0-2.25,2.15,10.34,10.34,0,0,0-.3,12.28A9.76,9.76,0,0,0,394,64.18a10.11,10.11,0,0,0,2.6,1.49,10.48,10.48,0,0,0,9.9-1.21,10.68,10.68,0,0,0,4-5.64,22.14,22.14,0,0,0,.49-2.57,8.21,8.21,0,0,1-.3,2.62,10.52,10.52,0,0,1-4,5.88,10.67,10.67,0,0,1-4.6,2,10.8,10.8,0,0,1-5.7-.59,10,10,0,0,1-2.72-1.54,10.12,10.12,0,0,1-2.25-2.36,10.8,10.8,0,0,1,.32-12.88,10.11,10.11,0,0,1,2.37-2.25,10.44,10.44,0,0,1,2.79-1.4,10.81,10.81,0,0,1,5.72-.3,10.73,10.73,0,0,1,8.2,8.25A8,8,0,0,1,411,56.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.18 60.57 394.86 56.43 396.31 54.58 399.88 57.35 404.98 51.52 406.75 53.06 400.18 60.57",
    style: {
      fill: "#FF822F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Goal--inject-19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 172.69,
    cy: 122.52,
    r: 38.25,
    transform: "translate(-36.06 158) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.24,
    cy: 124.11,
    r: 33.75,
    transform: "translate(-37.31 158.14) rotate(-45)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.24,
    cy: 124.11,
    r: 33.75,
    transform: "translate(-37.31 158.14) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 172.33,
    cy: 120.38,
    r: 33.75,
    transform: "translate(-36.36 95.14) rotate(-28.04)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.33,
    cy: 120.38,
    r: 22.6,
    transform: "translate(-36.19 146.97) rotate(-42.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.39,120.66a11.06,11.06,0,1,1-10.78-11.34A11.06,11.06,0,0,1,183.39,120.66Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 96.27 195.72 89.05 203.25 81.39 203.58 89.17 196.46 96.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.33 90.94 204.91 90.15 197.28 97.13 204.72 98.11 212.33 90.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M173.81,120.26l26.29-19.05a31,31,0,0,0-3.13-4L173.86,118.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M203.91,88.09,193.14,98.34l-17.07,16.25-3.93,3.73c-1.24,1.18.61,3.1,1.85,1.92L184.76,110l17.07-16.25L205.76,90c1.24-1.18-.61-3.1-1.85-1.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.38,
    cy: 213.01,
    r: 35.56,
    transform: "matrix(0.53, -0.85, 0.85, 0.53, -140, 173.15)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 178.55,
    width: 56.68,
    height: 71.9,
    rx: 3.88,
    transform: "translate(-32.73 16.46) rotate(-9.07)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.12,
    y: 182.51,
    width: 50.43,
    height: 63.98,
    transform: "translate(-32.73 16.46) rotate(-9.07)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.65,
    y: 178.43,
    width: 22.06,
    height: 7.49,
    transform: "translate(-27.69 15.32) rotate(-9.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.62 179.6 76.93 174.64 86.21 173.15 86.2 178.39 78.62 179.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.59,193.07c0,.14-8.33,1.59-18.65,3.24S66.22,199.18,66.2,199s8.33-1.6,18.66-3.24S103.57,192.92,103.59,193.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.38,198c0,.14-8.33,1.59-18.66,3.24S67,204.1,67,204s8.32-1.6,18.65-3.25S104.35,197.84,104.38,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.16,202.91c0,.14-8.33,1.59-18.65,3.24S67.79,209,67.77,208.88s8.33-1.6,18.66-3.25S105.14,202.76,105.16,202.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,207.83c0,.14-8.33,1.59-18.66,3.24s-18.71,2.87-18.73,2.73,8.33-1.6,18.65-3.25S105.92,207.68,106,207.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.73,212.75c0,.14-8.33,1.59-18.65,3.24s-18.71,2.87-18.74,2.73,8.33-1.6,18.66-3.25S106.71,212.6,106.73,212.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.52,217.66c0,.15-8.33,1.6-18.65,3.25s-18.72,2.87-18.74,2.73,8.33-1.6,18.65-3.25S107.5,217.52,107.52,217.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,222.58c0,.15-8.33,1.6-18.65,3.25s-18.71,2.87-18.74,2.73,8.33-1.6,18.66-3.25S108.28,222.44,108.3,222.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09,227.5c0,.15-8.33,1.6-18.65,3.25s-18.72,2.87-18.74,2.73,8.33-1.6,18.66-3.25S109.07,227.36,109.09,227.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.88,232.42c0,.15-8.33,1.6-18.66,3.25s-18.71,2.87-18.73,2.73,8.32-1.6,18.65-3.25S109.85,232.28,109.88,232.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.18,242.94l-1,.89a5.37,5.37,0,0,1-7.56-.47h0a1.46,1.46,0,0,1,.13-2.07l6.84-6a1.46,1.46,0,0,1,2.07.13h0A5.36,5.36,0,0,1,87.18,242.94Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.67,202.35l4.16,12.78,25.3,28.72,8.94-7.9L62.78,207.62l-12.32-6A.57.57,0,0,0,49.67,202.35Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.78,207.62a.87.87,0,0,1-1.21.67,2.63,2.63,0,0,1-3.45,3.6A3.07,3.07,0,0,1,53.8,215l-4.13-12.68a.57.57,0,0,1,.79-.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.1,206.73s2.68.89,3.7-3l-4.34-2.09a.57.57,0,0,0-.79.69Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M58.12,211.89l25.24,28.22-4.23,3.74-25.3-28.72,0-.1a3,3,0,0,0,1.32.27A3.08,3.08,0,0,0,58,213,3.19,3.19,0,0,0,58.12,211.89Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M61.57,208.29,86.93,237l1.14-1L62.78,207.62a.92.92,0,0,1-1,.74A1.72,1.72,0,0,1,61.57,208.29Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 76.44,
    y: 237.47,
    width: 12.9,
    height: 3.26,
    transform: "translate(-137.5 114.73) rotate(-41.44)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trust--inject-19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.79,
    cy: 353.09,
    r: 35.56,
    transform: "translate(-41.29 12.67) rotate(-6.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,359.12c-.44.1-29.55,23.48-29.55,23.48L66.83,365.93,86.53,340l15.57-1.76,3.57-1.51Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,357.66c.33.35,29,25.29,29,25.29a7.26,7.26,0,0,0,4.81.62c3-.52,2-3.66,2-3.66a4.33,4.33,0,0,0,4.81-.1,3.32,3.32,0,0,0,1.11-4.31s1.3,1.14,3.45-.14,1.1-3.92,1.1-3.92,2.52,1.44,4.56.11,1.78-4.59.16-6.68S97,355,97,355L86.52,337.92a4.11,4.11,0,0,0-2-1.74c-1.35-.46-7.06,1.29-7.06,1.29l-9.83-1.77Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,372.78a9.45,9.45,0,0,1-2.84-.63,3.16,3.16,0,0,1-1.87-2.09,3.56,3.56,0,0,1,.68-2.62,5.57,5.57,0,0,1,2.85-2.28,3.9,3.9,0,0,1,3.54.5,3.07,3.07,0,0,1,1.12,3.3,8.09,8.09,0,0,1,3.13-1,2.79,2.79,0,0,1,2.74,1.48,3.1,3.1,0,0,1-.2,2.45,7.71,7.71,0,0,1,2.79-.11,3.41,3.41,0,0,1,2.32,1.43,2.24,2.24,0,0,1-.12,2.62,5.18,5.18,0,0,1,3.68,0,3.06,3.06,0,0,1,1.46,2.36,4.68,4.68,0,0,1-.65,2.75,6.67,6.67,0,0,1-5.78,3.35,4,4,0,0,1-2.7-.94,2.25,2.25,0,0,1-.51-2.67A7.18,7.18,0,0,1,74.7,380a2.84,2.84,0,0,1-1.37-3.39,5.17,5.17,0,0,1-3.26-.68A2.64,2.64,0,0,1,68.91,373",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3,369.25c.1.11-.61,1-1.58,2s-1.85,1.7-2,1.6.61-1,1.59-2S72.2,369.14,72.3,369.25Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.89,377a9.82,9.82,0,0,1,2.47-3.11,10,10,0,0,1,3.24-2.3,35.48,35.48,0,0,1-2.88,2.68A33.11,33.11,0,0,1,72.89,377Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,376.1A9.31,9.31,0,0,1,81,378.79a8.91,8.91,0,0,1-2.6,2.18,14.32,14.32,0,0,1,2.22-2.54A14,14,0,0,1,83,376.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6,375.12a10.38,10.38,0,0,1,3.45,2.21,10.33,10.33,0,0,1,2.71,3.07c-.11.1-1.35-1.23-3.05-2.67A36.2,36.2,0,0,1,87.6,375.12Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.62,371a13.59,13.59,0,0,1,3.84,2.08,13.34,13.34,0,0,1,3.32,2.83,29.4,29.4,0,0,1-3.62-2.41A29.93,29.93,0,0,1,92.62,371Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.08,364.64a11.59,11.59,0,0,1,3.64,3.09,11.46,11.46,0,0,1,2.51,4c-.13.07-1.21-1.75-2.91-3.71S98,364.77,98.08,364.64Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.02,
    y: 331.98,
    width: 6.88,
    height: 28.18,
    transform: "translate(157.46 8.42) rotate(25.94)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.96,
    y: 326.88,
    width: 7.92,
    height: 31.7,
    transform: "translate(155.34 10.94) rotate(25.94)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.37,
    y: 327.9,
    width: 7.92,
    height: 31.7,
    transform: "translate(372.43 606.61) rotate(155.49)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.67,336.71a23.5,23.5,0,0,0-3.57,1.51s-16.57-.84-18.85.07-6.71,11.07-7,13,2.79,13.13,2.79,13.13,5.84,1.86,7.56-2.7a13.48,13.48,0,0,0,.11-8.77l1.66-1.89s4.78,5.47,9.65,3.67a88.14,88.14,0,0,1,14-4.26Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.15,
    y: 332.57,
    width: 6.88,
    height: 28.18,
    transform: "translate(360.77 614.95) rotate(155.49)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.16,352.16s-.19.23-.61.55a13,13,0,0,1-1.93,1.16A14.51,14.51,0,0,1,90.35,353a12.33,12.33,0,0,1-1.77-1.38c-.39-.36-.57-.59-.55-.61s.91.74,2.52,1.68a15.24,15.24,0,0,0,13.92.81C106.18,352.79,107.11,352.08,107.16,352.16Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.37,253.49l-7.84-1.34a23.83,23.83,0,1,1,6.62-5.36h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.37,253.49s0-.16-.09-.45-.15-.75-.26-1.3c-.23-1.15-.55-2.8-1-4.94l.17.07h0a.11.11,0,0,1-.15,0,.11.11,0,0,1,0-.13,23.81,23.81,0,0,0,5.11-10.31,23.14,23.14,0,0,0,.39-7.56,23.62,23.62,0,0,0-17.44-20.32,24,24,0,0,0-10.87-.21,23.08,23.08,0,0,0-10.21,5,23.56,23.56,0,0,0,26.43,38.69.1.1,0,0,1,.07,0l5.79,1.07,1.51.29.52.1-.48-.06-1.49-.23-5.89-.94h.07a23.66,23.66,0,0,1-11.33,3A24,24,0,0,1,431.71,213a23.5,23.5,0,0,1,10.44-5.14,24.56,24.56,0,0,1,11.1.22,24.13,24.13,0,0,1,15.27,12.39,23.81,23.81,0,0,1-3.28,26.43l-.15-.16h0a.11.11,0,0,1,.15,0,.08.08,0,0,1,0,0c.36,2.18.65,3.87.84,5l.21,1.28A2.8,2.8,0,0,1,466.37,253.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,228.46a7.21,7.21,0,0,0-1.92-3.9,7,7,0,0,0-3.66-2.17,5.73,5.73,0,0,0-4.37.93,5.64,5.64,0,0,0-1.76,2.06,5.67,5.67,0,0,0-1.7-1.78,5.73,5.73,0,0,0-4.4-.78,7,7,0,0,0-3.59,2.29,7.3,7.3,0,0,0-1.79,4,8.83,8.83,0,0,0,1.19,5.4,12.54,12.54,0,0,0,4.36,3.95c2.83,1.64,6.56,3.69,6.56,3.69s3.08-2.39,5.86-4.12a12.45,12.45,0,0,0,4.22-4.1A8.76,8.76,0,0,0,459.05,228.46Z",
    style: {
      fill: "#FF822F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.08,225.82,178,190.55c-.31-8.78,4.53-16.27,13.31-16.33l.81,0a15.7,15.7,0,0,1,14.9,15.2c.22,7.61.37,16,.12,20.07-.53,8.41-9,9.29-9,9.29s-.11,5.12-.12,7.59l1.92,5.79L193,230.45Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.12,218.82A20.39,20.39,0,0,1,187.33,215s2.31,6.45,10.74,6.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,196.41a1.2,1.2,0,0,1-1.22,1.15,1.15,1.15,0,0,1-1.18-1.14,1.2,1.2,0,0,1,1.22-1.16A1.15,1.15,0,0,1,203.12,196.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,193.08c-.16.15-1-.57-2.33-.63s-2.27.54-2.4.37.1-.35.53-.63a3.31,3.31,0,0,1,1.93-.49,3.19,3.19,0,0,1,1.84.7C205,192.73,205.11,193,205,193.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.22,196.44a1.2,1.2,0,0,1-1.22,1.15,1.14,1.14,0,0,1-1.18-1.14,1.21,1.21,0,0,1,1.22-1.16A1.16,1.16,0,0,1,191.22,196.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.34,192.74c-.16.15-1-.57-2.32-.63s-2.28.53-2.41.37.1-.35.53-.63a3.24,3.24,0,0,1,1.93-.49,3.19,3.19,0,0,1,1.85.7C192.3,192.38,192.42,192.67,192.34,192.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,202.91a8.91,8.91,0,0,1,2.12-.27c.33,0,.65-.07.72-.29a1.68,1.68,0,0,0-.17-1c-.27-.82-.56-1.67-.85-2.57a42.18,42.18,0,0,1-1.86-6.68,42.3,42.3,0,0,1,2.39,6.52l.81,2.58a1.9,1.9,0,0,1,.1,1.3.81.81,0,0,1-.56.45,2,2,0,0,1-.57,0A8.57,8.57,0,0,1,196.47,202.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,188.72c-.2.32-1.43-.09-3-.2s-2.81.06-2.95-.29c-.06-.16.22-.45.77-.69a4.83,4.83,0,0,1,2.29-.33,4.92,4.92,0,0,1,2.2.7C192.83,188.24,193.05,188.56,193,188.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.28,189.29c-.28.28-1.32-.06-2.59-.12s-2.34.11-2.58-.2c-.1-.16.08-.45.56-.71a4.35,4.35,0,0,1,4.16.26C205.27,188.84,205.4,189.15,205.28,189.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36,196.81c-.14-.07-5.7-2-5.8,3.76s5.69,4.68,5.71,4.51S178.36,196.81,178.36,196.81Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.55,202.87s-.1.07-.28.14a1,1,0,0,1-.75,0,2.49,2.49,0,0,1-1.1-2.25,3.3,3.3,0,0,1,.3-1.43,1.15,1.15,0,0,1,.77-.75.51.51,0,0,1,.59.28c.08.16,0,.28.07.29s.12-.1.08-.33a.63.63,0,0,0-.22-.37.78.78,0,0,0-.55-.16,1.45,1.45,0,0,0-1.07.88,3.43,3.43,0,0,0-.37,1.6,2.58,2.58,0,0,0,1.41,2.51,1.09,1.09,0,0,0,.92-.13C176.53,203,176.57,202.88,176.55,202.87Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.4,203.67c.2,0,.2,1.31,1.33,2.26s2.53.8,2.54,1-.31.26-.91.27a3.31,3.31,0,0,1-2.12-.75,2.91,2.91,0,0,1-1-1.9C192.16,204,192.31,203.66,192.4,203.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.71,182a1.41,1.41,0,0,0-.63-.81,4.15,4.15,0,0,0-2.15-.39,12.2,12.2,0,0,1-5.24-1.44,5.76,5.76,0,0,0,1.57-1,3.63,3.63,0,0,0,1.12-3.58.84.84,0,0,0-.44-.56c-.37-.12-.71.24-1,.53a3.11,3.11,0,0,1-3,1.18,5.1,5.1,0,0,1-2.18-.7l-.07-.08-.86-.91h0a19.08,19.08,0,0,0-5.86-4.53,19.57,19.57,0,0,0-10.43-1c-3,.71-5.63,3-6.1,6a6,6,0,0,0-6.1-.7l0,0c-2.25.75-3.57,3.08-4.27,5.34,0,.13-.08.25-.11.37a8.79,8.79,0,0,1-3.07,2.87c-.21.12-.46.27-.5.52s.18.45.38.6a4.33,4.33,0,0,0,1.78.79,9,9,0,0,1-.77,1.55c-.26.42-.57.93-.36,1.38a1,1,0,0,0,1,.45,2.79,2.79,0,0,0,1.05-.45l-.79,1.77a5.25,5.25,0,0,0,2.43-.11c.43,2.13.71,6.08,1.22,7.53,1.53.06,1.91-.1,2.67.18,1,.35.58,2.11,1.88,1.63.67-.24,1.74-2.72,2-3.39a33,33,0,0,0,1.72-13.89,10.4,10.4,0,0,1,3.31-2.29l-.1.09c2.37-.77,5.05-1.52,7.26-.37,1.72.89,2.7,2.71,4,4.18a12,12,0,0,0,8.8,4.51c.28,2.55.29,6.71.37,9.09l2.12-4.71v0c.17-.28.31-.55.45-.83l.05-.09h0c.22-.44.42-.89.69-1.33l0,0a1.48,1.48,0,0,0,2.2-1.94,3,3,0,0,0-.7-.73,2.36,2.36,0,0,0,2.22.62,1.84,1.84,0,0,0,1.34-1.79,1.56,1.56,0,0,0-.9-1.28,5.22,5.22,0,0,0,3-.6C218.3,183.29,218.89,182.74,218.71,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.14,175.66a6.66,6.66,0,0,0-.86.75,6,6,0,0,0-1.35,2.78,9.93,9.93,0,0,0-.26,2.13c0,.78,0,1.61.06,2.49a21.28,21.28,0,0,1,0,2.77,10.6,10.6,0,0,1-.22,1.45,3,3,0,0,1-.62,1.4,1.3,1.3,0,0,1-1.2.38,1.9,1.9,0,0,1-1.06-.63,4.35,4.35,0,0,1-.77-2.16l.18,0a6.92,6.92,0,0,1-1.06,1.74,2.51,2.51,0,0,1-1.66.86,1.6,1.6,0,0,1-.87-.17,1.49,1.49,0,0,1-.58-.59,1.47,1.47,0,0,1-.16-.76,1.07,1.07,0,0,1,.28-.65l.09.09a5.46,5.46,0,0,1-1.84,1.32,5.9,5.9,0,0,1-.56.2l-.21,0,.2-.08.55-.23a5.75,5.75,0,0,0,1.77-1.34l.09.08a1.07,1.07,0,0,0-.08,1.25,1.32,1.32,0,0,0,.52.53,1.59,1.59,0,0,0,.79.14,2.36,2.36,0,0,0,1.54-.82,7.1,7.1,0,0,0,1-1.7l.13-.27.05.29a4.13,4.13,0,0,0,.73,2.06,1.77,1.77,0,0,0,.94.57,1.11,1.11,0,0,0,1-.32,2.79,2.79,0,0,0,.58-1.31,10.32,10.32,0,0,0,.22-1.43,20.87,20.87,0,0,0,0-2.74c0-.88-.07-1.71-.05-2.5a11.63,11.63,0,0,1,.29-2.17,6.07,6.07,0,0,1,1.43-2.79A3.61,3.61,0,0,1,186.14,175.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05,184.41l-.07.05-.21.15a2.27,2.27,0,0,1-.36.22,5,5,0,0,1-.52.26,7.49,7.49,0,0,1-3.62.58,9.51,9.51,0,0,1-5.05-2,16.63,16.63,0,0,1-4.27-5.13c-.59-1-1.07-2.09-1.6-3.07a11.31,11.31,0,0,0-1.83-2.6,5.74,5.74,0,0,0-2.4-1.53,4.13,4.13,0,0,0-2.45,0,4.85,4.85,0,0,0-1.78,1,4.77,4.77,0,0,0-1,1.21,5.78,5.78,0,0,0-.46,1.26s0,0,0-.09,0-.15,0-.26a4.42,4.42,0,0,1,.34-.94,4.69,4.69,0,0,1,1-1.26,4.91,4.91,0,0,1,1.81-1.07,4.39,4.39,0,0,1,1.22-.22,4.12,4.12,0,0,1,1.33.17,5.88,5.88,0,0,1,2.48,1.55,11.1,11.1,0,0,1,1.87,2.64c.54,1,1,2,1.6,3.06a16.58,16.58,0,0,0,4.21,5.09,9.55,9.55,0,0,0,4.95,2,7.59,7.59,0,0,0,3.58-.51A12.93,12.93,0,0,0,212.05,184.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.89,180.72a1.33,1.33,0,0,1-.3.2,5.57,5.57,0,0,1-.91.44,8.64,8.64,0,0,1-1.42.43,9.28,9.28,0,0,1-1.82.21,10.24,10.24,0,0,1-1.82-.17,8.16,8.16,0,0,1-1.44-.4,5.8,5.8,0,0,1-.91-.42,1.71,1.71,0,0,1-.32-.19s.48.21,1.28.48a10.81,10.81,0,0,0,1.42.36,12.27,12.27,0,0,0,1.79.14,10.83,10.83,0,0,0,1.78-.18,10.32,10.32,0,0,0,1.41-.39C212.42,180.94,212.88,180.69,212.89,180.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68,442l-.87,15.95s15.92,6.25,16.05,9.22l-31-.59.35-24.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.25,456.41a1.26,1.26,0,0,0-.9,1.43,1.22,1.22,0,0,0,1.41.91,1.34,1.34,0,0,0,.94-1.52,1.25,1.25,0,0,0-1.56-.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.86,466.56l.14-2.51,29.67,1.5s1.36.63,1.19,1.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,457.79c0,.15-.77.2-1.52.67s-1.17,1.11-1.3,1,.1-.93,1-1.49S197.35,457.65,197.32,457.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.54,459.19c0,.15-.63.39-1.15,1s-.69,1.31-.84,1.3-.23-.87.44-1.64S200.54,459.05,200.54,459.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.31,463.12c-.13,0-.33-.73.07-1.55s1.12-1.14,1.18-1-.38.57-.7,1.25S202.47,463.11,202.31,463.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,454.13c-.06.13-.75-.09-1.61-.05s-1.53.3-1.61.17.58-.66,1.59-.69S197.19,454,197.11,454.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16,440.41l-1.68,19.26,3.06,15.61a2,2,0,0,1-1.69,2.35h0a2,2,0,0,1-1.71-.62c-2.76-3-12.87-14.15-12.67-15.55.24-1.62.43-20.43.43-20.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,477.63l-14.29-17.47-.06.82a3,3,0,0,0,.59,2c1.13,1.52,4.35,5.64,12,14.05a2,2,0,0,0,1.76.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.92,454.19a1.19,1.19,0,0,1,.22,1.58,1.14,1.14,0,0,1-1.56.24,1.27,1.27,0,0,1-.24-1.68,1.21,1.21,0,0,1,1.66-.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156,468.92a5.8,5.8,0,0,1,1.79-1.4,6.15,6.15,0,0,1,2.24-.28s-.21-.21-.66-.3a3,3,0,0,0-1.75.19,3.15,3.15,0,0,0-1.37,1.1C156,468.61,155.93,468.9,156,468.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.19,471.59a14.84,14.84,0,0,1,1.76-.72,13.12,13.12,0,0,1,1.9-.12,2.18,2.18,0,0,0-2-.3C157.7,470.71,157.09,471.53,157.19,471.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.63,465.44a20.75,20.75,0,0,1,2.65-1.29,20.23,20.23,0,0,1,2.9-.49,5.43,5.43,0,0,0-5.55,1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,459.54c0,.12,1.14-.25,2.53-.22s2.47.45,2.52.33a3.8,3.8,0,0,0-2.51-.75A3.89,3.89,0,0,0,153.65,459.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,453.88a9.54,9.54,0,0,1,2.63-.3,9.77,9.77,0,0,1,2.52.81s-.16-.3-.59-.58a4.23,4.23,0,0,0-1.89-.65,4.33,4.33,0,0,0-2,.26C154.22,453.62,154,453.83,154,453.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,452.5a1.56,1.56,0,0,0,.08-.73,5.29,5.29,0,0,0-.46-1.95,2.28,2.28,0,0,0-.89-1.13.79.79,0,0,0-.91.12,1.26,1.26,0,0,0-.36.85,2.79,2.79,0,0,0,2.28,2.74,3.25,3.25,0,0,0,3.29-1.49,1.15,1.15,0,0,0,.12-.93.79.79,0,0,0-.79-.47,2.87,2.87,0,0,0-1.32.58,5.62,5.62,0,0,0-1.41,1.42,1.74,1.74,0,0,0-.34.64,9.57,9.57,0,0,1,1.92-1.81,2.7,2.7,0,0,1,1.16-.48.43.43,0,0,1,.43.26.76.76,0,0,1-.11.6,2.89,2.89,0,0,1-2.87,1.26,2.43,2.43,0,0,1-2-2.3,1,1,0,0,1,.22-.6.42.42,0,0,1,.5-.07,2,2,0,0,1,.78.94A7.27,7.27,0,0,1,156.66,452.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,308a68.76,68.76,0,0,1,1.5,20.19c-.33,4.29-14.81,123-14.81,123H180.18l5.5-111.56-1.6.35s-10.67,47.58-11.54,55.28c-.79,6.92-9.79,57.23-9.79,57.23l-17.87.2,5.71-66.53,6.64-63.85,2.5-18.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6,328.21a3.27,3.27,0,0,0,.81.46,9.16,9.16,0,0,0,2.42.85,4.93,4.93,0,0,0,1.8,0,3.76,3.76,0,0,0,1.89-.9,4.58,4.58,0,0,0,1.14-2c.23-.76.36-1.55.52-2.35.63-3.22,1-6.16,1.29-8.29.13-1.07.21-1.94.25-2.54a3.67,3.67,0,0,0,0-.93,4.3,4.3,0,0,0-.19.92c-.1.68-.23,1.51-.38,2.51-.32,2.12-.78,5-1.4,8.25-.32,1.59-.53,3.2-1.53,4.15a4,4,0,0,1-3.37.88,11,11,0,0,1-2.4-.71A4.21,4.21,0,0,0,182.6,328.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48,313.08s-.13-.1-.4-.12a1.77,1.77,0,0,0-1.1.35,2,2,0,0,0-.82,1.51,1.94,1.94,0,0,0,3.3,1.24,1.94,1.94,0,0,0,.37-1.68,1.7,1.7,0,0,0-.59-1c-.22-.17-.37-.19-.38-.18a2.25,2.25,0,0,1,.69,1.22,1.73,1.73,0,0,1-.38,1.37,1.59,1.59,0,0,1-2.63-1,1.72,1.72,0,0,1,.62-1.28A2.3,2.3,0,0,1,188.48,313.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.13,262.11c-.08-2-3.19-16.45-3.19-16.7S177,224,177,224l.68-6.64,14.9,8.93s6.34-4.76,6.19-5l3.49,21,7.1,65.68s-2.43,3-11.73,4.32c-11.59,1.7-28.32-4.32-28.32-4.32S177.21,264.12,177.13,262.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M211.64,330.94s-2.19,1.66-3.53-8.3-5.29-51.73-5.29-51.73L200,227.68l8.52,25.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M178.45,298.5s-3.92,38.23-5.4,37.48-15.78-6.38-15.78-6.38l1.44-12.35Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "196.29 231.82 194.44 234.55 191.66 234.55 190.17 231.82 191.81 228.36 194.01 228.48 196.29 231.82",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,226.25a3.16,3.16,0,0,0,.66.5l1.86,1.24c1.58,1,3.78,2.44,6.22,4l2.3,1.43.16.1.09-.16a30.4,30.4,0,0,0,2.41-5c.25-.64.44-1.15.57-1.51a2,2,0,0,0,.17-.56,14.67,14.67,0,0,0-1,2,39.49,39.49,0,0,1-2.5,4.91l.26,0-2.29-1.45c-2.44-1.53-4.67-2.9-6.29-3.88l-1.93-1.13A4.28,4.28,0,0,0,178.15,226.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,229a4.79,4.79,0,0,0-.81,1c-.48.63-1.13,1.54-1.87,2.6h.3c-.3-.42-.62-.88-.94-1.36-.94-1.4-1.78-2.69-2.43-3.59a7.54,7.54,0,0,0-1.14-1.4,10.83,10.83,0,0,0,.91,1.55c.59.94,1.4,2.24,2.34,3.65.32.49.65,1,1,1.37l.16.21.14-.22c.72-1.06,1.34-2,1.76-2.67A5.29,5.29,0,0,0,199.48,229Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.44 234.55 202.82 297.86 197.49 308.92 188.48 297.27 191.66 234.55 194.44 234.55",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27,217.93c-.52.4-6.42,6.11-6.42,6.11S157.35,225.55,157,226s-.4,28.56-.32,29.18c.76,6.67,3.35,29.57,3.35,29.57L148.9,323.34l23.2,9.54s4.71-23.8,6.92-36.66,1.55-16.51,1.29-29-3-43.21-3-43.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,279.9a5.34,5.34,0,0,0-.05-.61c-.05-.39-.11-1-.23-1.73-.24-1.49-.61-3.65-1.14-6.3-1-5.31-2.61-12.61-4.43-20.66-1.46-6.45-2.86-12.4-4-17.16l0,.15,2.74-2.34.11-.09-.11-.11-2.77-2.61,0,.11c.55-1.4,1-2.52,1.31-3.32.14-.36.25-.65.33-.88a1.1,1.1,0,0,0,.1-.31,1.3,1.3,0,0,0-.15.29c-.1.22-.22.51-.38.86l-1.4,3.28,0,.07.05.05,2.74,2.66v-.2l-2.76,2.3-.08.06,0,.1c1.09,4.79,2.45,10.74,3.93,17.18,1.82,8,3.43,15.33,4.54,20.62.56,2.65,1,4.79,1.25,6.28.14.74.22,1.32.3,1.71A2.88,2.88,0,0,0,179,279.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,323.34a2,2,0,0,0,.43.22l1.29.56,4.81,2,16.6,6.89.21.09,0-.23c.5-2.68,1-5.55,1.58-8.51l4.28-23.48c.52-3,1-5.41,1.25-7.13.14-.81.24-1.46.32-1.94,0-.2.06-.36.08-.5s0-.17,0-.18a.69.69,0,0,0-.05.17c0,.14-.07.3-.11.5-.1.47-.23,1.12-.39,1.93-.34,1.71-.8,4.13-1.38,7.1-1.13,6-2.68,14.31-4.39,23.46-.54,3-1.07,5.83-1.56,8.51l.25-.14-16.65-6.76L150.66,324l-1.3-.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26,291.56a10.2,10.2,0,0,0,.33-2.15c.14-1.33.26-3.18.29-5.22s0-3.9-.15-5.23a10.71,10.71,0,0,0-.27-2.16,12.91,12.91,0,0,0,0,2.17c0,1.33.07,3.18,0,5.21s-.1,3.88-.17,5.21A14.91,14.91,0,0,0,164.26,291.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,295a2.55,2.55,0,0,0,.39-.53c.23-.36.54-.88.92-1.54a51.5,51.5,0,0,0,2.58-5.31,50.7,50.7,0,0,0,2-5.57c.21-.73.36-1.32.45-1.74a2,2,0,0,0,.1-.65,22.29,22.29,0,0,0-.81,2.31c-.48,1.42-1.17,3.38-2.06,5.5s-1.79,4-2.46,5.33A19.86,19.86,0,0,0,163.48,295Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.32,281.44l.27-.78,4.38,4.4s9.2-.07,10.91.54a1.77,1.77,0,0,1,.47,3.18s1.29,2-.37,3.25l-1,.59s1,2.19-.58,3.13-1.41.33-1.4,1.22-.44,2.09-1.25,2.3-9.71-3.2-11.52-4.24a31.62,31.62,0,0,1-4.94-4.48Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,229.18c-2.15,2.9-5.68,8.32-5.68,8.32s-18.87,14.57-23.49,18.34c-6.61,5.41-3,12.3-1.49,14.52s23,23.84,23,23.84l9.19-11.14-13.74-17.53.11-1.18,17.07-9.22,2.87,6.72.05-30.25-1.8-5.35-.8-.3A9.56,9.56,0,0,0,151.64,229.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,238.37c-.1,0,.26,4.89.82,10.89s1.1,10.87,1.2,10.86-.26-4.89-.82-10.89S155.41,238.36,155.3,238.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.86,259.62a20.91,20.91,0,0,1,5.45,2.27,21.15,21.15,0,0,1,4.33,4,5.6,5.6,0,0,0-.95-1.49,13.39,13.39,0,0,0-7.08-4.56A5.36,5.36,0,0,0,129.86,259.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,287.65c.1.05.47-.46.84-1.13s.59-1.27.49-1.32-.47.46-.83,1.13S151.6,287.6,151.69,287.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,218c.09,0-1.64-4.86-1.64-4.86l-13.26,5,1.94,5.28,13.11-5.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.09,329.74a2.37,2.37,0,0,1-3.53-1.86L206,280.58l-7-58.43,2.46,2.08s13.07,1,13.39,1.16,2.93,8.23,4.09,18.14.28,40.73.28,40.73l4.92,38.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,281.75a5.18,5.18,0,0,0,0-.64c0-.42-.05-1-.05-1.82,0-1.59,0-3.89,0-6.72,0-5.68.16-13.52.36-22.18.14-5.91.28-11.44.39-16.12v-.1l-.09,0-3.17-1.71,0,.22,2.16-3.15.06-.09-.08-.07-4.18-4-1.14-1.05a4.49,4.49,0,0,0-.4-.35,2.25,2.25,0,0,0,.36.4l1.08,1.09,4.11,4.05,0-.16-2.19,3.12-.1.13.15.08,3.16,1.74-.09-.15c-.16,4.67-.31,10.2-.45,16.12-.19,8.66-.29,16.51-.25,22.19,0,2.84.08,5.13.15,6.72,0,.8.1,1.41.12,1.83A3.25,3.25,0,0,0,207.19,281.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.68,308.69a1.39,1.39,0,0,0,0,.36c0,.28.06.61.1,1,.11.94.25,2.2.43,3.74.39,3.15.94,7.51,1.58,12.32.23,1.69.45,3.32.66,4.84l0,.27.24-.13,7.92-4.48,2.28-1.32a5.44,5.44,0,0,0,.8-.52,5.48,5.48,0,0,0-.86.41l-2.34,1.23-8,4.35.27.14c-.2-1.52-.41-3.15-.64-4.84-.64-4.81-1.24-9.16-1.69-12.31-.23-1.53-.42-2.78-.56-3.72-.06-.4-.12-.74-.17-1A1.5,1.5,0,0,0,208.68,308.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.91,225.39a5.59,5.59,0,0,1,3.67,1.57c1.46,1.52,4.6,4.27,4.6,4.27L241,236l-4-15.14,14.45-5.25,4.06,14s4.12,12.85,3.6,15c-1.38,5.79-9,7.74-10.76,8.18-3.28.84-28.65,2.14-28.65,2.14l-4.64-21.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,245.8c0-.05-.54-.41-1.37-1.11a14.64,14.64,0,0,1-2.76-3.17,14.33,14.33,0,0,1-1.7-3.83,16.07,16.07,0,0,0-.44-1.71,5.36,5.36,0,0,0,.17,1.77,12.21,12.21,0,0,0,1.64,4,12.36,12.36,0,0,0,2.92,3.17A5.08,5.08,0,0,0,247.16,245.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,234.12a5,5,0,0,0,0,1.06c0,.75.1,1.72.17,2.88.16,2.42.36,5.78.53,9.49s.26,7.06.32,9.5c0,1.16.05,2.12.07,2.88a5.69,5.69,0,0,0,.08,1.06,5.69,5.69,0,0,0,.08-1.06c0-.68,0-1.67,0-2.89,0-2.43,0-5.8-.21-9.51s-.41-7.07-.64-9.5c-.11-1.21-.21-2.19-.29-2.86A7.33,7.33,0,0,0,218.13,234.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.68,203.53s-2.21-2.57-3.36-2-2.51,2-2.48,3,.52,1.85,1,1.71a7.5,7.5,0,0,0,1.57-1.34l2.06,1.8,0,2.9L236,210.84l-1.37-1.7-.14-2.25s-1.31-.66-1.51,1.21-.15,5.16,1.94,6.25,5.54,2.36,5.54,2.36l8-3-.3-9.24s2.38-3.95,2.27-5.3-.88-5.38-.88-5.38a1,1,0,0,0-1.39.75,24.3,24.3,0,0,0-.05,4.58l-2,3.16-1.67-11.61s-1.82-.65-1.86,2.06.75,9.19.43,9.26-1.28.3-1.45-1c-.14-1.06-1.49-6.51-2.08-8.86a.65.65,0,0,0-1.16-.22,3.4,3.4,0,0,0-.62,2.29c.17,2.4,1.12,6.88,1.2,7.4A9.54,9.54,0,0,1,238.68,203.53Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,212.67c-.06,0-.25-.27-.64-.67a5.42,5.42,0,0,0-1.78-1.22,5.54,5.54,0,0,0-2.12-.41c-.56,0-.91.08-.93,0a1.71,1.71,0,0,1,.91-.29,4.63,4.63,0,0,1,4.13,1.72C243.13,212.3,243.24,212.65,243.2,212.67Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderM);
export default __webpack_public_path__ + "static/media/orderM.d62647c20865a69ca6e72b4102638710.svg";
export { ForwardRef as ReactComponent };